import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSTimestamp: number;
};

export type Query = {
  __typename?: 'Query';
  checkLastUpdate?: Maybe<AppointTimestamps>;
  checkPatients: IsPatients;
  getAppoint: Appoint;
  getBlock: AppointBlock;
  getClinic: Clinic;
  getComment?: Maybe<Comment>;
  getComments?: Maybe<Comments>;
  getForm?: Maybe<Form>;
  getFormById?: Maybe<Form>;
  getManeger: Maneger;
  getMenu: Menu;
  getNotification?: Maybe<Notification>;
  getOrg: Org;
  getPatients: Patient;
  getPatientsByNumber: Patient;
  getPatientsForBackOffice: Patient;
  getPHRInfo?: Maybe<PhrInfo>;
  getPHRInfoById?: Maybe<PhrInfo>;
  getRoles: Role;
  getShift: Shift;
  getTodayAppoint: Appoints;
  getTodayShift: Shifts;
  getWeeklyShift: Shifts;
  isEntry: IsEntry;
  listAppointById?: Maybe<Appoints>;
  listCategorys: Categorys;
  listClinics: Clinics;
  listFacilities: Facilities;
  listManeger: Manegers;
  listMenu: Menus;
  listOrgs: Orgs;
  listPatients: Patients;
  listPatientsByName: Patients;
  listPeriodAppoint: Appoints;
  listPeriodAppointById: Appoints;
  listPeriodNotification?: Maybe<Notifications>;
  listPeriodPHRInfo?: Maybe<PhrInfos>;
  listPeriodPHRInfoById?: Maybe<PhrInfos>;
  listRoles: Roles;
  listShift: Shifts;
  listTodayAppoint: Appoints;
  scanPeriodAppoint: Appoints;
  scanPeriodBlock: AppointBlocks;
};


export type QueryCheckLastUpdateArgs = {
  appointId: Scalars['ID'];
  beforeUpdated_at: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryCheckPatientsArgs = {
  DNumber: Scalars['Int'];
  SNumber: Scalars['Int'];
};


export type QueryGetAppointArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetBlockArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetClinicArgs = {
  clinic_id: Scalars['ID'];
  org_id: Scalars['ID'];
};


export type QueryGetCommentArgs = {
  id: Scalars['ID'];
};


export type QueryGetCommentsArgs = {
  clinic_id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
};


export type QueryGetFormArgs = {
  access_token: Scalars['String'];
};


export type QueryGetFormByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetManegerArgs = {
  id: Scalars['ID'];
};


export type QueryGetMenuArgs = {
  SDK_ID: Scalars['ID'];
};


export type QueryGetNotificationArgs = {
  access_token: Scalars['String'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetOrgArgs = {
  org_id: Scalars['ID'];
};


export type QueryGetPatientsArgs = {
  access_token: Scalars['String'];
};


export type QueryGetPatientsByNumberArgs = {
  number: Scalars['Int'];
  type: Scalars['String'];
};


export type QueryGetPatientsForBackOfficeArgs = {
  id: Scalars['ID'];
};


export type QueryGetPhrInfoArgs = {
  access_token: Scalars['String'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetPhrInfoByIdArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type QueryGetRolesArgs = {
  id: Scalars['ID'];
};


export type QueryGetShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
};


export type QueryGetTodayAppointArgs = {
  choice?: InputMaybe<Scalars['Int']>;
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
};


export type QueryGetTodayShiftArgs = {
  date: Scalars['AWSTimestamp'];
};


export type QueryGetWeeklyShiftArgs = {
  id: Scalars['ID'];
  weekEnd: Scalars['AWSTimestamp'];
  weekStart: Scalars['AWSTimestamp'];
};


export type QueryIsEntryArgs = {
  access_token?: InputMaybe<Scalars['String']>;
};


export type QueryListAppointByIdArgs = {
  id: Scalars['ID'];
};


export type QueryListCategorysArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListFacilitiesArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListManegerArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListMenuArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListPatientsArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListPatientsByNameArgs = {
  name: Scalars['String'];
};


export type QueryListPeriodAppointArgs = {
  access_token: Scalars['String'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodAppointByIdArgs = {
  endDate: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodNotificationArgs = {
  access_token: Scalars['String'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodPhrInfoArgs = {
  access_token: Scalars['String'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListPeriodPhrInfoByIdArgs = {
  endDate: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryListRolesArgs = {
  clinic_id: Scalars['ID'];
};


export type QueryListTodayAppointArgs = {
  choice?: InputMaybe<Scalars['Int']>;
  date: Scalars['AWSTimestamp'];
};


export type QueryScanPeriodAppointArgs = {
  clinic_id: Scalars['ID'];
  endDate: Scalars['AWSTimestamp'];
  startDate: Scalars['AWSTimestamp'];
};


export type QueryScanPeriodBlockArgs = {
  clinic_id: Scalars['ID'];
  endTime: Scalars['AWSTimestamp'];
  startTime: Scalars['AWSTimestamp'];
};

export type AppointTimestamps = {
  __typename?: 'AppointTimestamps';
  appointId: Scalars['ID'];
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  isUpdated?: Maybe<Scalars['Boolean']>;
  startTime: Scalars['AWSTimestamp'];
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type IsPatients = {
  __typename?: 'isPatients';
  isPatients: Scalars['Boolean'];
};

export type Appoint = {
  __typename?: 'Appoint';
  appoint?: Maybe<Scalars['String']>;
  appointId?: Maybe<Scalars['ID']>;
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  clinic_id?: Maybe<Scalars['ID']>;
  confirmedEndTime?: Maybe<Scalars['AWSTimestamp']>;
  confirmedTime?: Maybe<Scalars['AWSTimestamp']>;
  consultationTime?: Maybe<Scalars['AWSTimestamp']>;
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDubbleBooking?: Maybe<Scalars['Boolean']>;
  isFirstVisiting?: Maybe<Scalars['Boolean']>;
  menuId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  remarks?: Maybe<Scalars['String']>;
  secondEndTime?: Maybe<Scalars['AWSTimestamp']>;
  secondStartTime?: Maybe<Scalars['AWSTimestamp']>;
  staffIds?: Maybe<Array<Maybe<StaffId>>>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: Maybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: Maybe<Scalars['AWSTimestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type Cancel = {
  __typename?: 'Cancel';
  cancelReason?: Maybe<Scalars['String']>;
  isCancel?: Maybe<Scalars['Boolean']>;
  radioCancelReason?: Maybe<Scalars['Int']>;
};

export type StaffId = {
  __typename?: 'StaffId';
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
};

export type AppointBlock = {
  __typename?: 'AppointBlock';
  clinic_id?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  isDelete?: Maybe<Scalars['Boolean']>;
  isNonAccepted?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};

export type Clinic = {
  __typename?: 'Clinic';
  clinic_id: Scalars['ID'];
  clinic_label: Scalars['String'];
  clinic_name: Scalars['String'];
  created_at: Scalars['AWSTimestamp'];
  isDelete: Scalars['Boolean'];
  org_id: Scalars['ID'];
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type Comment = {
  __typename?: 'Comment';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Comments = {
  __typename?: 'Comments';
  clinic_id: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['ID']>;
  date: Scalars['AWSTimestamp'];
};

export type Form = {
  __typename?: 'Form';
  common: Common;
  dental?: Maybe<Dental>;
  medical?: Maybe<Medical>;
  orthodontics?: Maybe<Orthodontics>;
};

export type Common = {
  __typename?: 'Common';
  Q1?: Maybe<CommonQ1>;
  Q2?: Maybe<CommonQ2>;
  Q3?: Maybe<CommonQ3>;
  Q4?: Maybe<CommonQ4>;
  Q5?: Maybe<CommonQ5>;
  Q6?: Maybe<CommonQ6>;
};

export type CommonQ1 = {
  __typename?: 'commonQ1';
  answerQ1?: Maybe<Scalars['String']>;
  diseaseQ1: Scalars['String'];
  selected_clinicQ1?: Maybe<Scalars['String']>;
  selected_medicineQ1?: Maybe<Scalars['String']>;
};

export type CommonQ2 = {
  __typename?: 'commonQ2';
  answerQ2?: Maybe<Scalars['String']>;
  commentQ2?: Maybe<Scalars['String']>;
  selectedQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommonQ3 = {
  __typename?: 'commonQ3';
  answerQ3?: Maybe<Scalars['String']>;
  selectedQ3?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommonQ4 = {
  __typename?: 'commonQ4';
  answerQ4?: Maybe<Scalars['String']>;
  selected_optionsQ4?: Maybe<Scalars['String']>;
  selectedQ4?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommonQ5 = {
  __typename?: 'commonQ5';
  answerQ5?: Maybe<Scalars['String']>;
};

export type CommonQ6 = {
  __typename?: 'commonQ6';
  answerQ6?: Maybe<Scalars['String']>;
  commentQ6?: Maybe<Scalars['String']>;
  dateQ6?: Maybe<Scalars['String']>;
  selectedQ6?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Dental = {
  __typename?: 'Dental';
  Q1?: Maybe<DentalQ1>;
  Q2?: Maybe<DentalQ2>;
  Q3?: Maybe<DentalQ3>;
  Q4?: Maybe<DentalQ4>;
  Q5?: Maybe<DentalQ5>;
};

export type DentalQ1 = {
  __typename?: 'dentalQ1';
  commentQ1?: Maybe<Scalars['String']>;
  dateQ1?: Maybe<Scalars['AWSTimestamp']>;
  selectedQ1?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ2 = {
  __typename?: 'dentalQ2';
  commentQ2?: Maybe<Scalars['String']>;
  selectedQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ3 = {
  __typename?: 'dentalQ3';
  answerQ3?: Maybe<Scalars['String']>;
  commentQ3?: Maybe<Scalars['String']>;
  selectedQ3?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ4 = {
  __typename?: 'dentalQ4';
  selectedQ4?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DentalQ5 = {
  __typename?: 'dentalQ5';
  selectedQ5?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Medical = {
  __typename?: 'Medical';
  Q1?: Maybe<MedicalQ1>;
  Q2?: Maybe<MedicalQ2>;
  Q3?: Maybe<MedicalQ3>;
  Q4?: Maybe<MedicalQ4>;
  Q5?: Maybe<MedicalQ5>;
  Q6?: Maybe<MedicalQ6>;
};

export type MedicalQ1 = {
  __typename?: 'medicalQ1';
  commentQ1?: Maybe<Scalars['String']>;
  selectedQ1?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MedicalQ2 = {
  __typename?: 'medicalQ2';
  bodyQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
  commentQ2: Scalars['String'];
  faceQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MedicalQ3 = {
  __typename?: 'medicalQ3';
  answerQ3?: Maybe<Scalars['String']>;
  clinic_anotherQ3?: Maybe<Scalars['String']>;
  clinic_otherQ3?: Maybe<Scalars['String']>;
  clinic_salonQ3?: Maybe<Scalars['String']>;
  selected_fatDissolvingQ3?: Maybe<Scalars['String']>;
  selected_laserQ3?: Maybe<Scalars['String']>;
  selected_peelingQ3?: Maybe<Scalars['String']>;
  selectedQ3?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MedicalQ4 = {
  __typename?: 'medicalQ4';
  commentQ4?: Maybe<Scalars['String']>;
  constipationQ4?: Maybe<Scalars['String']>;
  favoriteQ4: Scalars['String'];
  selectedQ4?: Maybe<Array<Maybe<Scalars['String']>>>;
  sleepQ4?: Maybe<Scalars['String']>;
  stomachQ4?: Maybe<Scalars['String']>;
  ultravioletRaysQ4?: Maybe<Scalars['String']>;
};

export type MedicalQ5 = {
  __typename?: 'medicalQ5';
  doctorsCosmeQ5?: Maybe<Scalars['String']>;
  selectedQ5?: Maybe<Array<Maybe<Scalars['String']>>>;
  skincareItemQ5?: Maybe<Scalars['String']>;
};

export type MedicalQ6 = {
  __typename?: 'medicalQ6';
  commentQ6?: Maybe<Scalars['String']>;
  selectedQ6?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Orthodontics = {
  __typename?: 'Orthodontics';
  Q1?: Maybe<OrthodonticsQ1>;
  Q10?: Maybe<OrthodonticsQ10>;
  Q2?: Maybe<OrthodonticsQ2>;
  Q3?: Maybe<OrthodonticsQ3>;
  Q4?: Maybe<OrthodonticsQ4>;
  Q5?: Maybe<OrthodonticsQ5>;
  Q6?: Maybe<OrthodonticsQ6>;
  Q7?: Maybe<OrthodonticsQ7>;
  Q8?: Maybe<OrthodonticsQ8>;
  Q9?: Maybe<OrthodonticsQ9>;
};

export type OrthodonticsQ1 = {
  __typename?: 'orthodonticsQ1';
  commentQ1?: Maybe<Scalars['String']>;
  selectedQ1?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ10 = {
  __typename?: 'orthodonticsQ10';
  commentQ10?: Maybe<Scalars['String']>;
  selectedQ10?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ2 = {
  __typename?: 'orthodonticsQ2';
  commentQ2?: Maybe<Scalars['String']>;
  selectedQ2?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ3 = {
  __typename?: 'orthodonticsQ3';
  answerQ3?: Maybe<Scalars['String']>;
  commentQ3?: Maybe<Scalars['String']>;
  dateQ3?: Maybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ4 = {
  __typename?: 'orthodonticsQ4';
  answerQ4?: Maybe<Scalars['String']>;
  dateQ4?: Maybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ5 = {
  __typename?: 'orthodonticsQ5';
  commentQ5?: Maybe<Scalars['String']>;
  dateQ5?: Maybe<Scalars['AWSTimestamp']>;
  selectedQ5?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ6 = {
  __typename?: 'orthodonticsQ6';
  selectedQ6?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ7 = {
  __typename?: 'orthodonticsQ7';
  commentQ7?: Maybe<Scalars['String']>;
  selectedQ7?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrthodonticsQ8 = {
  __typename?: 'orthodonticsQ8';
  answerQ8?: Maybe<Scalars['String']>;
};

export type OrthodonticsQ9 = {
  __typename?: 'orthodonticsQ9';
  selectedQ9?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Maneger = {
  __typename?: 'Maneger';
  clinic_id?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  isDelete?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rights: Scalars['String'];
  role: Scalars['String'];
};

export type Menu = {
  __typename?: 'Menu';
  abbreviation?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  clinic_id?: Maybe<Scalars['ID']>;
  courponId?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  isDelete?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parts?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  SDK_ID: Scalars['ID'];
  status: Scalars['String'];
  subCategoryId?: Maybe<Scalars['ID']>;
  time: Scalars['Int'];
  type: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  category: Scalars['String'];
  content: Scalars['String'];
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  number: Scalars['String'];
};

export type Org = {
  __typename?: 'Org';
  created_at: Scalars['AWSTimestamp'];
  isDelete: Scalars['Boolean'];
  org_id: Scalars['ID'];
  org_label: Scalars['String'];
  org_name: Scalars['String'];
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type Patient = {
  __typename?: 'Patient';
  access_token?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  age?: Maybe<Scalars['Int']>;
  birthday?: Maybe<Scalars['AWSTimestamp']>;
  clinic_id?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  DNumber?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  invitationNumber?: Maybe<Scalars['String']>;
  kana?: Maybe<Name>;
  lineId?: Maybe<Scalars['ID']>;
  name?: Maybe<Name>;
  notEntry?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  searchFull?: Maybe<Scalars['String']>;
  searchKana?: Maybe<Scalars['String']>;
  searchName?: Maybe<Scalars['String']>;
  SNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Boolean']>;
  tel?: Maybe<Scalars['String']>;
  undefinedToken?: Maybe<Scalars['Boolean']>;
};

export type Address = {
  __typename?: 'address';
  house?: Maybe<Scalars['String']>;
  post?: Maybe<Scalars['String']>;
  prefectures?: Maybe<Scalars['String']>;
};

export type Name = {
  __typename?: 'Name';
  first?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['String']>;
};

export type PhrInfo = {
  __typename?: 'PHRInfo';
  buying?: Maybe<Buying>;
  confirmed?: Maybe<Confirmed>;
  date: Scalars['AWSTimestamp'];
  expires_at?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  payment?: Maybe<Payment>;
  phr?: Maybe<Phr>;
};

export type Buying = {
  __typename?: 'Buying';
  items?: Maybe<Array<Maybe<Item>>>;
};

export type Item = {
  __typename?: 'Item';
  count: Scalars['Int'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type Confirmed = {
  __typename?: 'Confirmed';
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  consultationTime?: Maybe<Scalars['AWSTimestamp']>;
  endTime: Scalars['AWSTimestamp'];
  menuId: Scalars['String'];
  parts: Scalars['String'];
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  staffIds?: Maybe<Array<Maybe<StaffId>>>;
  startTime: Scalars['AWSTimestamp'];
  type: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  courpon?: Maybe<Scalars['Int']>;
  method: Scalars['String'];
  price: Scalars['String'];
  ticket?: Maybe<Ticket>;
};

export type Ticket = {
  __typename?: 'Ticket';
  buy_at: Scalars['AWSTimestamp'];
  counts: Counts;
  expires_at: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type Counts = {
  __typename?: 'Counts';
  current: Scalars['Int'];
  max: Scalars['Int'];
};

export type Phr = {
  __typename?: 'PHR';
  complement: Scalars['String'];
  links: Array<Maybe<Link>>;
  progress: Progress;
  related: Scalars['String'];
};

export type Link = {
  __typename?: 'Link';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type Progress = {
  __typename?: 'Progress';
  count: Scalars['Int'];
  text: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  clinic_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
};

export type Shift = {
  __typename?: 'Shift';
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']>;
  workingTimes: WorkingTimesType;
};

export type WorkingTimesType = {
  __typename?: 'workingTimesType';
  am: Array<Maybe<Scalars['String']>>;
  pm: Array<Maybe<Scalars['String']>>;
};

export type Appoints = {
  __typename?: 'Appoints';
  Appoints: Array<Maybe<Appoint>>;
};

export type Shifts = {
  __typename?: 'Shifts';
  Shifts: Array<Maybe<Shift>>;
};

export type IsEntry = {
  __typename?: 'isEntry';
  isEntry: Scalars['Boolean'];
};

export type Categorys = {
  __typename?: 'Categorys';
  Categorys: Array<Maybe<Category>>;
};

export type Category = {
  __typename?: 'Category';
  clinic_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDelete: Scalars['Boolean'];
  mainCategory: Scalars['String'];
  name: Scalars['String'];
};

export type Clinics = {
  __typename?: 'Clinics';
  clinics: Array<Clinic>;
};

export type Facilities = {
  __typename?: 'Facilities';
  Facilities: Array<Facility>;
};

export type Facility = {
  __typename?: 'facility';
  clinic_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  isDelete?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
};

export type Manegers = {
  __typename?: 'Manegers';
  Manegers: Array<Maneger>;
};

export type Menus = {
  __typename?: 'Menus';
  Menus: Array<Menu>;
};

export type Orgs = {
  __typename?: 'Orgs';
  orgs: Array<Org>;
};

export type Patients = {
  __typename?: 'Patients';
  Patients: Array<Patient>;
};

export type Notifications = {
  __typename?: 'Notifications';
  Notifications: Array<Maybe<Notification>>;
};

export type PhrInfos = {
  __typename?: 'PHRInfos';
  PHRInfos: Array<Maybe<PhrInfo>>;
};

export type Roles = {
  __typename?: 'Roles';
  Roles: Array<Role>;
};

export type AppointBlocks = {
  __typename?: 'AppointBlocks';
  AppointBlocks?: Maybe<Array<Maybe<AppointBlock>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAppoint: Appoint;
  addBlock: AppointBlock;
  addCategory: Category;
  addClinic: Clinic;
  addComment?: Maybe<Comment>;
  addComments?: Maybe<Comments>;
  addFacility: Facility;
  addForm: Form;
  addFormById: Form;
  addManeger: Maneger;
  addMenu: Menu;
  addOrg: Org;
  addPatients?: Maybe<Patient>;
  addPatientsById?: Maybe<Patient>;
  addPatientsByQR?: Maybe<Patient>;
  addPHRInfo?: Maybe<PhrInfo>;
  addRoles: Role;
  addShift: Shift;
  batchDeleteMenu?: Maybe<Menu>;
  batchWriteShift?: Maybe<Shift>;
  changeStatus?: Maybe<AppointCustom>;
  checkDubbleBooking: IsDubbleBooking;
  checkNotAccepted: IsNonAccepted;
  deleteAppoint: Appoint;
  deleteBlock: AppointBlock;
  deleteCategory: Category;
  deleteClinic: Clinic;
  deleteFacility: Facility;
  deleteForm?: Maybe<Form>;
  deleteFormById?: Maybe<Form>;
  deleteManeger: Maneger;
  deleteMenu: Menu;
  deleteOrg: Org;
  deletePatients: Patient;
  deletePatientsById: Patient;
  deletePHRInfoConfirmed?: Maybe<PhrInfo>;
  deleteRoles: Role;
  deleteShift: Shift;
  getMenu: Menu;
  transactDeleteCategorys: TransactReturn;
  transactDeleteMenus?: Maybe<TransactReturn>;
  transactIndexMenus?: Maybe<TransactReturn>;
  transactPutClinics?: Maybe<TransactPutClinics>;
  updateAppoint: Appoint;
  updateAppointInfo: Appoint;
  updateBlock: AppointBlockCustom;
  updateBlockStatus: AppointBlockCustom;
  updateCategory: Category;
  updateClinic: Clinic;
  updateCommentAttrs?: Maybe<ReturnBoolean>;
  updateFacility: Facility;
  updateForm: Form;
  updateFormById: Form;
  updateManeger: Maneger;
  updateMenu: Menu;
  updateOrg: Org;
  updatePatients?: Maybe<Patient>;
  updatePatientsById?: Maybe<Patient>;
  updatePatientsSearch?: Maybe<Scalars['Boolean']>;
  updateRoles: Role;
  updateShift: Shift;
};


export type MutationAddAppointArgs = {
  appoint?: InputMaybe<Scalars['String']>;
  appointId?: InputMaybe<Scalars['ID']>;
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['String'];
  id: Scalars['ID'];
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  menuId: Scalars['String'];
  price: Scalars['Int'];
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  type: Scalars['String'];
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationAddBlockArgs = {
  clinic_id: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};


export type MutationAddCategoryArgs = {
  clinic_id: Scalars['ID'];
  mainCategory: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddClinicArgs = {
  AddClinicInput: AddClinicInput;
};


export type MutationAddCommentArgs = {
  comment: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationAddCommentsArgs = {
  clinic_id: Scalars['ID'];
  comment: Scalars['String'];
  date: Scalars['AWSTimestamp'];
};


export type MutationAddFacilityArgs = {
  clinic_id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  status: Scalars['Boolean'];
};


export type MutationAddFormArgs = {
  access_token: Scalars['String'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationAddFormByIdArgs = {
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  id: Scalars['ID'];
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationAddManegerArgs = {
  clinic_id: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rights: Scalars['String'];
  role: Scalars['String'];
};


export type MutationAddMenuArgs = {
  abbreviation?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parts?: InputMaybe<Scalars['String']>;
  role: Scalars['String'];
  status: Scalars['String'];
  subCategoryId: Scalars['ID'];
  time?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};


export type MutationAddOrgArgs = {
  AddOrgInput: AddOrgInput;
};


export type MutationAddPatientsArgs = {
  access_token: Scalars['String'];
  address: AddressInput;
  age?: InputMaybe<Scalars['Int']>;
  birthday: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender: Scalars['String'];
  group?: InputMaybe<Scalars['String']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana: NameInput;
  name: NameInput;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull: Scalars['String'];
  searchKana: Scalars['String'];
  SNumber?: InputMaybe<Scalars['Int']>;
  tel: Scalars['String'];
};


export type MutationAddPatientsByIdArgs = {
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana: NameInput;
  lineId?: InputMaybe<Scalars['ID']>;
  name: NameInput;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull: Scalars['String'];
  searchKana: Scalars['String'];
  SNumber?: InputMaybe<Scalars['Int']>;
  tel?: InputMaybe<Scalars['String']>;
};


export type MutationAddPatientsByQrArgs = {
  access_token: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationAddPhrInfoArgs = {
  PHRInfoInput: PhrInfoInput;
};


export type MutationAddRolesArgs = {
  clinic_id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']>;
  workingTimes: WorkingTimesInput;
};


export type MutationBatchDeleteMenuArgs = {
  SDK_IDs: Array<Scalars['ID']>;
};


export type MutationBatchWriteShiftArgs = {
  dates: Array<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']>;
  workingTimes: WorkingTimesInput;
};


export type MutationChangeStatusArgs = {
  appoint: Scalars['String'];
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  startTime: Scalars['AWSTimestamp'];
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationCheckDubbleBookingArgs = {
  date: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationCheckNotAcceptedArgs = {
  date: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationDeleteAppointArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationDeleteBlockArgs = {
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClinicArgs = {
  clinic_id: Scalars['ID'];
  org_id: Scalars['ID'];
};


export type MutationDeleteFacilityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFormArgs = {
  access_token: Scalars['String'];
};


export type MutationDeleteFormByIdArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteManegerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMenuArgs = {
  SDK_ID: Scalars['ID'];
};


export type MutationDeleteOrgArgs = {
  org_id: Scalars['ID'];
};


export type MutationDeletePatientsArgs = {
  access_token: Scalars['String'];
};


export type MutationDeletePatientsByIdArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePhrInfoConfirmedArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
};


export type MutationDeleteRolesArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
};


export type MutationGetMenuArgs = {
  SDK_ID: Scalars['ID'];
};


export type MutationTransactDeleteCategorysArgs = {
  SDK_IDs: Array<Scalars['ID']>;
};


export type MutationTransactDeleteMenusArgs = {
  SDK_IDs: Array<Scalars['ID']>;
};


export type MutationTransactIndexMenusArgs = {
  ModifyIndexMenus: Array<ModifyIndexMenus>;
};


export type MutationUpdateAppointArgs = {
  appoint?: InputMaybe<Scalars['String']>;
  appointId: Scalars['ID'];
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  clinic_id: Scalars['ID'];
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  date?: InputMaybe<Scalars['AWSTimestamp']>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  menuId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationUpdateAppointInfoArgs = {
  appoint?: InputMaybe<Scalars['String']>;
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  created_at?: InputMaybe<Scalars['AWSTimestamp']>;
  date?: InputMaybe<Scalars['AWSTimestamp']>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  menuId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['AWSTimestamp']>;
};


export type MutationUpdateBlockArgs = {
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
  color?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};


export type MutationUpdateBlockStatusArgs = {
  color?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  startTime: Scalars['AWSTimestamp'];
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['ID'];
  mainCategory?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateClinicArgs = {
  UpdateClinicValue: UpdateClinicInput;
};


export type MutationUpdateCommentAttrsArgs = {
  clinic_id: Scalars['ID'];
};


export type MutationUpdateFacilityArgs = {
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateFormArgs = {
  access_token: Scalars['String'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationUpdateFormByIdArgs = {
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  id: Scalars['ID'];
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
};


export type MutationUpdateManegerArgs = {
  color?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rights?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMenuArgs = {
  abbreviation?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  SDK_ID: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  time?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrgArgs = {
  UpdateOrgInput: UpdateOrgInput;
};


export type MutationUpdatePatientsArgs = {
  access_token: Scalars['String'];
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana?: InputMaybe<NameUpdateInput>;
  name?: InputMaybe<NameUpdateInput>;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull?: InputMaybe<Scalars['String']>;
  searchKana?: InputMaybe<Scalars['String']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  tel?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePatientsByIdArgs = {
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invitationNumber?: InputMaybe<Scalars['String']>;
  kana?: InputMaybe<NameUpdateInput>;
  name?: InputMaybe<NameUpdateInput>;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull?: InputMaybe<Scalars['String']>;
  searchKana?: InputMaybe<Scalars['String']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  tel?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateRolesArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateShiftArgs = {
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  shifts?: InputMaybe<Array<Scalars['Boolean']>>;
  workingTimes?: InputMaybe<WorkingTimesInput>;
};

export type CancelInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  isCancel?: InputMaybe<Scalars['Boolean']>;
  radioCancelReason?: InputMaybe<Scalars['Int']>;
};

export type StaffIdInput = {
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
};

export type AddClinicInput = {
  clinic_label: Scalars['String'];
  clinic_name: Scalars['String'];
  org_id: Scalars['ID'];
};

export type CommonInput = {
  Q1: CommonQ1Input;
  Q2: CommonQ2Input;
  Q3: CommonQ3Input;
  Q4: CommonQ4Input;
  Q5: CommonQ5Input;
  Q6: CommonQ6Input;
};

export type CommonQ1Input = {
  answerQ1?: InputMaybe<Scalars['String']>;
  diseaseQ1: Scalars['String'];
  selected_clinicQ1?: InputMaybe<Scalars['String']>;
  selected_medicineQ1?: InputMaybe<Scalars['String']>;
};

export type CommonQ2Input = {
  answerQ2?: InputMaybe<Scalars['String']>;
  commentQ2?: InputMaybe<Scalars['String']>;
  selectedQ2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommonQ3Input = {
  answerQ3: Scalars['String'];
  selectedQ3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommonQ4Input = {
  answerQ4?: InputMaybe<Scalars['String']>;
  selected_optionsQ4?: InputMaybe<Scalars['String']>;
  selectedQ4?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommonQ5Input = {
  answerQ5: Scalars['String'];
};

export type CommonQ6Input = {
  answerQ6: Scalars['String'];
  commentQ6?: InputMaybe<Scalars['String']>;
  dateQ6?: InputMaybe<Scalars['AWSTimestamp']>;
  selectedQ6?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalInput = {
  Q1: DentalQ1Input;
  Q2: DentalQ2Input;
  Q3: DentalQ3Input;
  Q4: DentalQ4Input;
  Q5: DentalQ5Input;
};

export type DentalQ1Input = {
  commentQ1?: InputMaybe<Scalars['String']>;
  dateQ1?: InputMaybe<Scalars['AWSTimestamp']>;
  selectedQ1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ2Input = {
  commentQ2?: InputMaybe<Scalars['String']>;
  selectedQ2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ3Input = {
  answerQ3?: InputMaybe<Scalars['String']>;
  commentQ3?: InputMaybe<Scalars['String']>;
  selectedQ3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ4Input = {
  selectedQ4?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DentalQ5Input = {
  selectedQ5?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MedicalInput = {
  Q1: MedicalQ1Input;
  Q2: MedicalQ2Input;
  Q3: MedicalQ3Input;
  Q4: MedicalQ4Input;
  Q5: MedicalQ5Input;
  Q6: MedicalQ6Input;
};

export type MedicalQ1Input = {
  commentQ1?: InputMaybe<Scalars['String']>;
  selectedQ1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MedicalQ2Input = {
  bodyQ2: Array<InputMaybe<Scalars['String']>>;
  commentQ2: Scalars['String'];
  faceQ2: Array<InputMaybe<Scalars['String']>>;
};

export type MedicalQ3Input = {
  answerQ3?: InputMaybe<Scalars['String']>;
  clinic_anotherQ3?: InputMaybe<Scalars['String']>;
  clinic_otherQ3?: InputMaybe<Scalars['String']>;
  clinic_salonQ3?: InputMaybe<Scalars['String']>;
  selected_fatDissolvingQ3?: InputMaybe<Scalars['String']>;
  selected_laserQ3?: InputMaybe<Scalars['String']>;
  selected_peelingQ3?: InputMaybe<Scalars['String']>;
  selectedQ3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MedicalQ4Input = {
  commentQ4?: InputMaybe<Scalars['String']>;
  constipationQ4?: InputMaybe<Scalars['String']>;
  favoriteQ4: Scalars['String'];
  selectedQ4?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sleepQ4?: InputMaybe<Scalars['String']>;
  stomachQ4?: InputMaybe<Scalars['String']>;
  ultravioletRaysQ4?: InputMaybe<Scalars['String']>;
};

export type MedicalQ5Input = {
  doctorsCosmeQ5?: InputMaybe<Scalars['String']>;
  selectedQ5?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skincareItemQ5?: InputMaybe<Scalars['String']>;
};

export type MedicalQ6Input = {
  commentQ6?: InputMaybe<Scalars['String']>;
  selectedQ6?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsInput = {
  Q1: OrthodonticsQ1Input;
  Q10: OrthodonticsQ10Input;
  Q2: OrthodonticsQ2Input;
  Q3: OrthodonticsQ3Input;
  Q4: OrthodonticsQ4Input;
  Q5: OrthodonticsQ5Input;
  Q6: OrthodonticsQ6Input;
  Q7: OrthodonticsQ7Input;
  Q8: OrthodonticsQ8Input;
  Q9: OrthodonticsQ9Input;
};

export type OrthodonticsQ1Input = {
  commentQ1?: InputMaybe<Scalars['String']>;
  selectedQ1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ10Input = {
  commentQ10?: InputMaybe<Scalars['String']>;
  selectedQ10?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ2Input = {
  commentQ2?: InputMaybe<Scalars['String']>;
  selectedQ2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ3Input = {
  answerQ3?: InputMaybe<Scalars['String']>;
  commentQ3?: InputMaybe<Scalars['String']>;
  dateQ3?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ4Input = {
  answerQ4?: InputMaybe<Scalars['String']>;
  dateQ4?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type OrthodonticsQ5Input = {
  commentQ5?: InputMaybe<Scalars['String']>;
  dateQ5?: InputMaybe<Scalars['AWSTimestamp']>;
  selectedQ5?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ6Input = {
  selectedQ6?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ7Input = {
  commentQ7?: InputMaybe<Scalars['String']>;
  selectedQ7?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrthodonticsQ8Input = {
  answerQ8?: InputMaybe<Scalars['String']>;
};

export type OrthodonticsQ9Input = {
  selectedQ9?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddOrgInput = {
  org_label: Scalars['String'];
  org_name: Scalars['String'];
};

export type AddressInput = {
  house: Scalars['String'];
  post: Scalars['String'];
  prefectures: Scalars['String'];
};

export type NameInput = {
  first: Scalars['String'];
  last: Scalars['String'];
};

export type AddressUpdateInput = {
  house?: InputMaybe<Scalars['String']>;
  post?: InputMaybe<Scalars['String']>;
  prefectures?: InputMaybe<Scalars['String']>;
};

export type PhrInfoInput = {
  buying?: InputMaybe<BuyingInput>;
  confirmed?: InputMaybe<ConfirmedInput>;
  date: Scalars['AWSTimestamp'];
  expires_at?: InputMaybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  payment?: InputMaybe<PaymentInput>;
  phr?: InputMaybe<PhrInput>;
};

export type BuyingInput = {
  items?: InputMaybe<Array<InputMaybe<ItemInput>>>;
};

export type ItemInput = {
  count: Scalars['Int'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type ConfirmedInput = {
  cancel?: InputMaybe<CancelInput>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  endTime: Scalars['AWSTimestamp'];
  menuId: Scalars['String'];
  parts: Scalars['String'];
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>>>;
  startTime: Scalars['AWSTimestamp'];
  type: Scalars['String'];
};

export type PaymentInput = {
  courpon?: InputMaybe<Scalars['Int']>;
  method: Scalars['String'];
  price: Scalars['String'];
  ticket?: InputMaybe<TicketInput>;
};

export type TicketInput = {
  buy_at: Scalars['AWSTimestamp'];
  counts: CountsInput;
  expires_at: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type CountsInput = {
  current: Scalars['Int'];
  max: Scalars['Int'];
};

export type PhrInput = {
  complement: Scalars['String'];
  links: Array<InputMaybe<LinkInput>>;
  progress: ProgressInput;
  related: Scalars['String'];
};

export type LinkInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ProgressInput = {
  count: Scalars['Int'];
  text: Scalars['String'];
};

export type WorkingTimesInput = {
  am: Array<InputMaybe<Scalars['String']>>;
  pm: Array<InputMaybe<Scalars['String']>>;
};

export type AppointCustom = {
  __typename?: 'AppointCustom';
  appoint?: Maybe<Scalars['String']>;
  appointId?: Maybe<Scalars['ID']>;
  cancel?: Maybe<Cancel>;
  cancelTime?: Maybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: Maybe<Scalars['AWSTimestamp']>;
  confirmedTime?: Maybe<Scalars['AWSTimestamp']>;
  consultationTime?: Maybe<Scalars['AWSTimestamp']>;
  created_at?: Maybe<Scalars['AWSTimestamp']>;
  date?: Maybe<Scalars['AWSTimestamp']>;
  endTime?: Maybe<Scalars['AWSTimestamp']>;
  facilityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isFirstVisiting?: Maybe<Scalars['Boolean']>;
  menuId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receptionTime?: Maybe<Scalars['AWSTimestamp']>;
  remarks?: Maybe<Scalars['String']>;
  secondEndTime?: Maybe<Scalars['AWSTimestamp']>;
  secondStartTime?: Maybe<Scalars['AWSTimestamp']>;
  staffIds?: Maybe<Array<Maybe<StaffIdCustom>>>;
  startTime?: Maybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: Maybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: Maybe<Scalars['AWSTimestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['AWSTimestamp']>;
};

export type StaffIdCustom = {
  __typename?: 'StaffIdCustom';
  id?: Maybe<Scalars['ID']>;
  index?: Maybe<Scalars['Int']>;
};

export type IsDubbleBooking = {
  __typename?: 'isDubbleBooking';
  isDubbleBooking: Scalars['Boolean'];
};

export type IsNonAccepted = {
  __typename?: 'isNonAccepted';
  isNonAccepted: Scalars['Boolean'];
};

export type TransactReturn = {
  __typename?: 'TransactReturn';
  TransactReturn?: Maybe<Scalars['Boolean']>;
};

export type ModifyIndexMenus = {
  index: Scalars['Int'];
  SDK_ID: Scalars['ID'];
};

export type TransactPutClinics = {
  __typename?: 'transactPutClinics';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type AppointBlockCustom = {
  __typename?: 'AppointBlockCustom';
  clinic_id?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['AWSTimestamp']>;
  facilityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDelete?: Maybe<Scalars['Boolean']>;
  isNonAccepted?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['AWSTimestamp']>;
};

export type UpdateClinicInput = {
  clinic_id: Scalars['ID'];
  clinic_label?: InputMaybe<Scalars['String']>;
  clinic_name?: InputMaybe<Scalars['String']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  org_id: Scalars['ID'];
};

export type ReturnBoolean = {
  __typename?: 'ReturnBoolean';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrgInput = {
  isDelete?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['ID']>;
  org_label?: InputMaybe<Scalars['String']>;
  org_name?: InputMaybe<Scalars['String']>;
};

export type NameUpdateInput = {
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
};

export type Forms = {
  __typename?: 'Forms';
  Forms: Array<Form>;
};

export type Res = Patient | Undefined;

export type Undefined = {
  __typename?: 'Undefined';
  undefinedToken?: Maybe<Scalars['Boolean']>;
};

export type StaffData = {
  __typename?: 'StaffData';
  id?: Maybe<Scalars['ID']>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type StaffDataInput = {
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GetPhrInfoQueryVariables = Exact<{
  access_token: Scalars['String'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetPhrInfoQuery = { __typename?: 'Query', getPHRInfo?: { __typename?: 'PHRInfo', date: number, expires_at?: number | null, buying?: { __typename?: 'Buying', items?: Array<{ __typename?: 'Item', count: number, name: string, price: number } | null> | null } | null, confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string, ticket?: { __typename?: 'Ticket', buy_at: number, expires_at: number, id: string, name: string, price: number, counts: { __typename?: 'Counts', current: number, max: number } } | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null } | null };

export type GetPhrInfoByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetPhrInfoByIdQuery = { __typename?: 'Query', getPHRInfoById?: { __typename?: 'PHRInfo', date: number, id: string, confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string } | null } | null };

export type ListPeriodPhrInfoQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodPhrInfoQuery = { __typename?: 'Query', listPeriodPHRInfo?: { __typename?: 'PHRInfos', PHRInfos: Array<{ __typename?: 'PHRInfo', date: number, expires_at?: number | null, id: string, buying?: { __typename?: 'Buying', items?: Array<{ __typename?: 'Item', count: number, name: string, price: number } | null> | null } | null, confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string, ticket?: { __typename?: 'Ticket', buy_at: number, expires_at: number, id: string, name: string, price: number, counts: { __typename?: 'Counts', current: number, max: number } } | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null } | null> } | null };

export type ListPeriodPhrInfoByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodPhrInfoByIdQuery = { __typename?: 'Query', listPeriodPHRInfoById?: { __typename?: 'PHRInfos', PHRInfos: Array<{ __typename?: 'PHRInfo', confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, phr?: { __typename?: 'PHR', progress: { __typename?: 'Progress', count: number } } | null } | null> } | null };

export type ListPeriodPhrInfoConfirmedQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodPhrInfoConfirmedQuery = { __typename?: 'Query', listPeriodPHRInfo?: { __typename?: 'PHRInfos', PHRInfos: Array<{ __typename?: 'PHRInfo', id: string, confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null } | null> } | null };

export type AddPhrInfoMutationVariables = Exact<{
  PHRInfoInput: PhrInfoInput;
}>;


export type AddPhrInfoMutation = { __typename?: 'Mutation', addPHRInfo?: { __typename?: 'PHRInfo', date: number, expires_at?: number | null, id: string, buying?: { __typename?: 'Buying', items?: Array<{ __typename?: 'Item', count: number, name: string, price: number } | null> | null } | null, confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null, payment?: { __typename?: 'Payment', courpon?: number | null, method: string, price: string, ticket?: { __typename?: 'Ticket', buy_at: number, expires_at: number, id: string, name: string, price: number, counts: { __typename?: 'Counts', current: number, max: number } } | null } | null, phr?: { __typename?: 'PHR', complement: string, related: string, links: Array<{ __typename?: 'Link', name: string, url: string } | null>, progress: { __typename?: 'Progress', count: number, text: string } } | null } | null };

export type GetPhrInfoConfirmedQueryVariables = Exact<{
  access_token: Scalars['String'];
  date: Scalars['AWSTimestamp'];
}>;


export type GetPhrInfoConfirmedQuery = { __typename?: 'Query', getPHRInfo?: { __typename?: 'PHRInfo', confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null } | null };

export type DeletePhrInfoConfirmedMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
}>;


export type DeletePhrInfoConfirmedMutation = { __typename?: 'Mutation', deletePHRInfoConfirmed?: { __typename?: 'PHRInfo', confirmed?: { __typename?: 'Confirmed', cancelTime?: number | null, consultationTime?: number | null, endTime: number, menuId: string, parts: string, receptionTime?: number | null, startTime: number, type: string, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null } | null };

export type ScanPeriodBlockQueryVariables = Exact<{
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
}>;


export type ScanPeriodBlockQuery = { __typename?: 'Query', scanPeriodBlock: { __typename?: 'AppointBlocks', AppointBlocks?: Array<{ __typename?: 'AppointBlock', id: string, startTime: number, endTime: number, facilityId: string, remarks?: string | null, color?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null, clinic_id?: string | null } | null> | null } };

export type AddBlockMutationVariables = Exact<{
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  clinic_id: Scalars['ID'];
}>;


export type AddBlockMutation = { __typename?: 'Mutation', addBlock: { __typename?: 'AppointBlock', id: string, startTime: number, endTime: number, facilityId: string, remarks?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null, clinic_id?: string | null } };

export type UpdateBlockMutationVariables = Exact<{
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  clinic_id: Scalars['ID'];
}>;


export type UpdateBlockMutation = { __typename?: 'Mutation', updateBlock: { __typename?: 'AppointBlockCustom', id: string, startTime?: number | null, endTime?: number | null, facilityId?: string | null, remarks?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null, clinic_id?: string | null } };

export type UpdateBlockStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  facilityId: Scalars['ID'];
  remarks?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBlockStatusMutation = { __typename?: 'Mutation', updateBlockStatus: { __typename?: 'AppointBlockCustom', id: string, startTime?: number | null, endTime?: number | null, facilityId?: string | null, remarks?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null } };

export type DeleteBlockMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type DeleteBlockMutation = { __typename?: 'Mutation', deleteBlock: { __typename?: 'AppointBlock', id: string, startTime: number, endTime: number, facilityId: string, remarks?: string | null, color?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null } };

export type GetBlockQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetBlockQuery = { __typename?: 'Query', getBlock: { __typename?: 'AppointBlock', id: string, startTime: number, endTime: number, facilityId: string, remarks?: string | null, color?: string | null, isNonAccepted?: boolean | null, isDelete?: boolean | null } };

export type CheckDubbleBookingMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
}>;


export type CheckDubbleBookingMutation = { __typename?: 'Mutation', checkDubbleBooking: { __typename?: 'isDubbleBooking', isDubbleBooking: boolean } };

export type ChangeStatusMutationVariables = Exact<{
  appoint: Scalars['String'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  receptionTime?: InputMaybe<Scalars['AWSTimestamp']>;
  cancelTime?: InputMaybe<Scalars['AWSTimestamp']>;
  consultationTime?: InputMaybe<Scalars['AWSTimestamp']>;
  cancel?: InputMaybe<CancelInput>;
}>;


export type ChangeStatusMutation = { __typename?: 'Mutation', changeStatus?: { __typename?: 'AppointCustom', appoint?: string | null, id?: string | null, startTime?: number | null, receptionTime?: number | null, consultationTime?: number | null, cancelTime?: number | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', isCancel?: boolean | null, cancelReason?: string | null, radioCancelReason?: number | null } | null } | null };

export type AddAppointMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime: Scalars['AWSTimestamp'];
  date: Scalars['AWSTimestamp'];
  appoint?: InputMaybe<Scalars['String']>;
  appointId?: InputMaybe<Scalars['ID']>;
  type: Scalars['String'];
  menuId: Scalars['String'];
  facilityId: Scalars['String'];
  price: Scalars['Int'];
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>> | InputMaybe<StaffIdInput>>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  clinic_id: Scalars['ID'];
}>;


export type AddAppointMutation = { __typename?: 'Mutation', addAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, isDubbleBooking?: boolean | null, created_at?: number | null, updated_at?: number | null, clinic_id?: string | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } };

export type DeleteAppointMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type DeleteAppointMutation = { __typename?: 'Mutation', deleteAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } };

export type UpdateAppointMutationVariables = Exact<{
  baseId: Scalars['ID'];
  baseStartTime: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  appoint?: InputMaybe<Scalars['String']>;
  appointId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>> | InputMaybe<StaffIdInput>>;
  menuId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
}>;


export type UpdateAppointMutation = { __typename?: 'Mutation', updateAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, isDubbleBooking?: boolean | null, created_at?: number | null, updated_at?: number | null, clinic_id?: string | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } };

export type UpdateAppointInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  endTime?: InputMaybe<Scalars['AWSTimestamp']>;
  appoint?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  staffIds?: InputMaybe<Array<InputMaybe<StaffIdInput>> | InputMaybe<StaffIdInput>>;
  menuId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  secondStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  secondEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdStartTime?: InputMaybe<Scalars['AWSTimestamp']>;
  thirdEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedTime?: InputMaybe<Scalars['AWSTimestamp']>;
  confirmedEndTime?: InputMaybe<Scalars['AWSTimestamp']>;
  remarks?: InputMaybe<Scalars['String']>;
  isFirstVisiting?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['AWSTimestamp'];
}>;


export type UpdateAppointInfoMutation = { __typename?: 'Mutation', updateAppointInfo: { __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } };

export type GetAppointQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
}>;


export type GetAppointQuery = { __typename?: 'Query', getAppoint: { __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } };

export type GetTodayAppointQueryVariables = Exact<{
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  choice?: InputMaybe<Scalars['Int']>;
}>;


export type GetTodayAppointQuery = { __typename?: 'Query', getTodayAppoint: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appointId?: string | null, appoint?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null> } };

export type ListPeriodAppointQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodAppointQuery = { __typename?: 'Query', listPeriodAppoint: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appointId?: string | null, appoint?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null> } };

export type ListPeriodAppointByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodAppointByIdQuery = { __typename?: 'Query', listPeriodAppointById: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null> } };

export type ListAppointByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListAppointByIdQuery = { __typename?: 'Query', listAppointById?: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null> } | null };

export type ListTodayAppointQueryVariables = Exact<{
  date: Scalars['AWSTimestamp'];
  choice?: InputMaybe<Scalars['Int']>;
}>;


export type ListTodayAppointQuery = { __typename?: 'Query', listTodayAppoint: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, secondEndTime?: number | null, secondStartTime?: number | null, startTime: number, thirdEndTime?: number | null, thirdStartTime?: number | null, type?: string | null, created_at?: number | null, updated_at?: number | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null> } };

export type ScanPeriodAppointQueryVariables = Exact<{
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
  clinic_id: Scalars['ID'];
}>;


export type ScanPeriodAppointQuery = { __typename?: 'Query', scanPeriodAppoint: { __typename?: 'Appoints', Appoints: Array<{ __typename?: 'Appoint', appoint?: string | null, appointId?: string | null, cancelTime?: number | null, confirmedEndTime?: number | null, confirmedTime?: number | null, consultationTime?: number | null, date: number, endTime: number, facilityId?: string | null, id: string, isFirstVisiting?: boolean | null, menuId?: string | null, price?: number | null, receptionTime?: number | null, remarks?: string | null, startTime: number, type?: string | null, created_at?: number | null, updated_at?: number | null, clinic_id?: string | null, cancel?: { __typename?: 'Cancel', cancelReason?: string | null, isCancel?: boolean | null, radioCancelReason?: number | null } | null, staffIds?: Array<{ __typename?: 'StaffId', id: string, index?: number | null } | null> | null } | null> } };

export type CheckLastUpdateQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['AWSTimestamp'];
  beforeUpdated_at: Scalars['AWSTimestamp'];
  appointId: Scalars['ID'];
}>;


export type CheckLastUpdateQuery = { __typename?: 'Query', checkLastUpdate?: { __typename?: 'AppointTimestamps', id: string, startTime: number, appointId: string, created_at?: number | null, updated_at?: number | null, isUpdated?: boolean | null } | null };

export type GetClinicQueryVariables = Exact<{
  org_id: Scalars['ID'];
  clinic_id: Scalars['ID'];
}>;


export type GetClinicQuery = { __typename?: 'Query', getClinic: { __typename?: 'Clinic', org_id: string, clinic_id: string, clinic_label: string, clinic_name: string, isDelete: boolean, created_at: number, updated_at?: number | null } };

export type GetClinicLabelQueryVariables = Exact<{
  org_id: Scalars['ID'];
  clinic_id: Scalars['ID'];
}>;


export type GetClinicLabelQuery = { __typename?: 'Query', getClinic: { __typename?: 'Clinic', clinic_label: string } };

export type ListClinicsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListClinicsQuery = { __typename?: 'Query', listClinics: { __typename?: 'Clinics', clinics: Array<{ __typename?: 'Clinic', org_id: string, clinic_id: string, clinic_label: string, clinic_name: string, isDelete: boolean, created_at: number, updated_at?: number | null }> } };

export type GetCommentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCommentQuery = { __typename?: 'Query', getComment?: { __typename?: 'Comment', comment?: string | null, id: string } | null };

export type AddCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment?: { __typename?: 'Comment', comment?: string | null, id: string } | null };

export type GetCommentsQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
}>;


export type GetCommentsQuery = { __typename?: 'Query', getComments?: { __typename?: 'Comments', clinic_id: string, date: number, comment?: string | null, commentId?: string | null } | null };

export type AddCommentsMutationVariables = Exact<{
  clinic_id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  comment: Scalars['String'];
}>;


export type AddCommentsMutation = { __typename?: 'Mutation', addComments?: { __typename?: 'Comments', clinic_id: string, date: number, comment?: string | null, commentId?: string | null } | null };

export type ListFacilitiesQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListFacilitiesQuery = { __typename?: 'Query', listFacilities: { __typename?: 'Facilities', Facilities: Array<{ __typename?: 'facility', id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null }> } };

export type ListFacilitieNamesQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListFacilitieNamesQuery = { __typename?: 'Query', listFacilities: { __typename?: 'Facilities', Facilities: Array<{ __typename?: 'facility', id: string, name: string, isDelete?: boolean | null }> } };

export type AddFacilityMutationVariables = Exact<{
  name: Scalars['String'];
  status: Scalars['Boolean'];
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
}>;


export type AddFacilityMutation = { __typename?: 'Mutation', addFacility: { __typename?: 'facility', id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null } };

export type DeleteFacilityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFacilityMutation = { __typename?: 'Mutation', deleteFacility: { __typename?: 'facility', id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null } };

export type UpdateFacilityMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateFacilityMutation = { __typename?: 'Mutation', updateFacility: { __typename?: 'facility', id: string, name: string, status?: boolean | null, isDelete?: boolean | null, index?: number | null } };

export type GetManegerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetManegerQuery = { __typename?: 'Query', getManeger: { __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null } };

export type ListManegerQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListManegerQuery = { __typename?: 'Query', listManeger: { __typename?: 'Manegers', Manegers: Array<{ __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null }> } };

export type ListManegerNameQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListManegerNameQuery = { __typename?: 'Query', listManeger: { __typename?: 'Manegers', Manegers: Array<{ __typename?: 'Maneger', id: string, name: string, isDelete?: boolean | null, index?: number | null }> } };

export type AddManegerMutationVariables = Exact<{
  role: Scalars['String'];
  name: Scalars['String'];
  rights: Scalars['String'];
  email: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
}>;


export type AddManegerMutation = { __typename?: 'Mutation', addManeger: { __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null } };

export type DeleteManegerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteManegerMutation = { __typename?: 'Mutation', deleteManeger: { __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null } };

export type UpDateManegerMutationVariables = Exact<{
  id: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rights?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type UpDateManegerMutation = { __typename?: 'Mutation', updateManeger: { __typename?: 'Maneger', id: string, role: string, name: string, rights: string, email: string, color?: string | null, isDelete?: boolean | null, index?: number | null } };

export type UpdateManegerColorMutationVariables = Exact<{
  id: Scalars['ID'];
  color: Scalars['String'];
}>;


export type UpdateManegerColorMutation = { __typename?: 'Mutation', updateManeger: { __typename?: 'Maneger', id: string, color?: string | null } };

export type ListCategorysQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListCategorysQuery = { __typename?: 'Query', listCategorys: { __typename?: 'Categorys', Categorys: Array<{ __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string, clinic_id?: string | null } | null> } };

export type AddCategoryMutationVariables = Exact<{
  mainCategory: Scalars['String'];
  name: Scalars['String'];
  clinic_id: Scalars['ID'];
}>;


export type AddCategoryMutation = { __typename?: 'Mutation', addCategory: { __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string, clinic_id?: string | null } };

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: { __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string } };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  mainCategory?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'Category', id: string, isDelete: boolean, mainCategory: string, name: string } };

export type TransactDeleteCategorysMutationVariables = Exact<{
  SDK_IDs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TransactDeleteCategorysMutation = { __typename?: 'Mutation', transactDeleteCategorys: { __typename?: 'TransactReturn', TransactReturn?: boolean | null } };

export type GetMenuQueryVariables = Exact<{
  SDK_ID: Scalars['ID'];
}>;


export type GetMenuQuery = { __typename?: 'Query', getMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null } };

export type GetMenuForPhrMutationVariables = Exact<{
  SDK_ID: Scalars['ID'];
}>;


export type GetMenuForPhrMutation = { __typename?: 'Mutation', getMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null } };

export type ListMenuQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListMenuQuery = { __typename?: 'Query', listMenu: { __typename?: 'Menus', Menus: Array<{ __typename?: 'Menu', amount?: number | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, courponId?: string | null, SDK_ID: string, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null }> } };

export type ListMenuNameQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListMenuNameQuery = { __typename?: 'Query', listMenu: { __typename?: 'Menus', Menus: Array<{ __typename?: 'Menu', SDK_ID: string, name: string, abbreviation?: string | null, isDelete?: boolean | null }> } };

export type AddMenuMutationVariables = Exact<{
  amount?: InputMaybe<Scalars['Int']>;
  role: Scalars['String'];
  name: Scalars['String'];
  abbreviation?: InputMaybe<Scalars['String']>;
  subCategoryId: Scalars['ID'];
  parts?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
  time?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
  clinic_id: Scalars['ID'];
}>;


export type AddMenuMutation = { __typename?: 'Mutation', addMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null, clinic_id?: string | null } };

export type DeleteMenuMutationVariables = Exact<{
  SDK_ID: Scalars['ID'];
}>;


export type DeleteMenuMutation = { __typename?: 'Mutation', deleteMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null } };

export type BatchDeleteMenuMutationVariables = Exact<{
  SDK_IDs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BatchDeleteMenuMutation = { __typename?: 'Mutation', batchDeleteMenu?: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, courponId?: string | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, parts?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null } | null };

export type UpDateMenuMutationVariables = Exact<{
  SDK_ID: Scalars['ID'];
  amount?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  abbreviation?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type UpDateMenuMutation = { __typename?: 'Mutation', updateMenu: { __typename?: 'Menu', SDK_ID: string, amount?: number | null, role: string, name: string, abbreviation?: string | null, subCategoryId?: string | null, status: string, time: number, type: string, isDelete?: boolean | null, index?: number | null } };

export type TransactDeleteMenusMutationVariables = Exact<{
  SDK_IDs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TransactDeleteMenusMutation = { __typename?: 'Mutation', transactDeleteMenus?: { __typename?: 'TransactReturn', TransactReturn?: boolean | null } | null };

export type TransactIndexMenusMutationVariables = Exact<{
  ModifyIndexMenus: Array<ModifyIndexMenus> | ModifyIndexMenus;
}>;


export type TransactIndexMenusMutation = { __typename?: 'Mutation', transactIndexMenus?: { __typename?: 'TransactReturn', TransactReturn?: boolean | null } | null };

export type ListPeriodNotificationQueryVariables = Exact<{
  access_token: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
  endDate: Scalars['AWSTimestamp'];
}>;


export type ListPeriodNotificationQuery = { __typename?: 'Query', listPeriodNotification?: { __typename?: 'Notifications', Notifications: Array<{ __typename?: 'Notification', id: string, number: string, date: number, content: string, category: string } | null> } | null };

export type GetOrgQueryVariables = Exact<{
  org_id: Scalars['ID'];
}>;


export type GetOrgQuery = { __typename?: 'Query', getOrg: { __typename?: 'Org', org_id: string, org_label: string, org_name: string, isDelete: boolean, created_at: number, updated_at?: number | null } };

export type GetOrgLabelQueryVariables = Exact<{
  org_id: Scalars['ID'];
}>;


export type GetOrgLabelQuery = { __typename?: 'Query', getOrg: { __typename?: 'Org', org_label: string } };

export type IsEntryQueryVariables = Exact<{
  access_token?: InputMaybe<Scalars['String']>;
}>;


export type IsEntryQuery = { __typename?: 'Query', isEntry: { __typename?: 'isEntry', isEntry: boolean } };

export type GetPatientsQueryVariables = Exact<{
  access_token: Scalars['String'];
}>;


export type GetPatientsQuery = { __typename?: 'Query', getPatients: { __typename?: 'Patient', DNumber?: number | null, SNumber?: number | null, age?: number | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, undefinedToken?: boolean | null, notEntry?: boolean | null, status?: boolean | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } };

export type ListPatientsByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type ListPatientsByNameQuery = { __typename?: 'Query', listPatientsByName: { __typename?: 'Patients', Patients: Array<{ __typename?: 'Patient', id?: string | null, DNumber?: number | null, SNumber?: number | null, age?: number | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, lineId?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, status?: boolean | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null }> } };

export type GetPatientsByNumberQueryVariables = Exact<{
  number: Scalars['Int'];
  type: Scalars['String'];
}>;


export type GetPatientsByNumberQuery = { __typename?: 'Query', getPatientsByNumber: { __typename?: 'Patient', DNumber?: number | null, SNumber?: number | null, age?: number | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, id?: string | null, invitationNumber?: string | null, lineId?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, status?: boolean | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } };

export type CheckPatientsQueryVariables = Exact<{
  DNumber: Scalars['Int'];
  SNumber: Scalars['Int'];
}>;


export type CheckPatientsQuery = { __typename?: 'Query', checkPatients: { __typename?: 'isPatients', isPatients: boolean } };

export type GetPatientsForBackOfficeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPatientsForBackOfficeQuery = { __typename?: 'Query', getPatientsForBackOffice: { __typename?: 'Patient', comment?: string | null, id?: string | null, lineId?: string | null, group?: string | null, gender?: string | null, email?: string | null, birthday?: number | null, age?: number | null, SNumber?: number | null, DNumber?: number | null, invitationNumber?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, status?: boolean | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } };

export type ListPatientsQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListPatientsQuery = { __typename?: 'Query', listPatients: { __typename?: 'Patients', Patients: Array<{ __typename?: 'Patient', DNumber?: number | null, SNumber?: number | null, id?: string | null, lineId?: string | null, age?: number | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, status?: boolean | null, clinic_id?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', last?: string | null, first?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null }> } };

export type AddPatientsMutationVariables = Exact<{
  DNumber?: InputMaybe<Scalars['Int']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  address: AddressInput;
  age?: InputMaybe<Scalars['Int']>;
  birthday: Scalars['AWSTimestamp'];
  comment?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender: Scalars['String'];
  group?: InputMaybe<Scalars['String']>;
  access_token: Scalars['String'];
  kana: NameInput;
  name: NameInput;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull: Scalars['String'];
  searchKana: Scalars['String'];
  tel: Scalars['String'];
  invitationNumber?: InputMaybe<Scalars['String']>;
  clinic_id: Scalars['ID'];
}>;


export type AddPatientsMutation = { __typename?: 'Mutation', addPatients?: { __typename?: 'Patient', DNumber?: number | null, SNumber?: number | null, age?: number | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, invitationNumber?: string | null, status?: boolean | null, clinic_id?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type AddPatientsByIdMutationVariables = Exact<{
  DNumber?: InputMaybe<Scalars['Int']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  comment?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  kana: NameInput;
  name: NameInput;
  remarks?: InputMaybe<Scalars['String']>;
  searchFull: Scalars['String'];
  searchKana: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  clinic_id: Scalars['ID'];
}>;


export type AddPatientsByIdMutation = { __typename?: 'Mutation', addPatientsById?: { __typename?: 'Patient', DNumber?: number | null, SNumber?: number | null, id?: string | null, lineId?: string | null, age?: number | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, invitationNumber?: string | null, status?: boolean | null, clinic_id?: string | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type AddPatientsByQrMutationVariables = Exact<{
  id: Scalars['ID'];
  access_token: Scalars['String'];
}>;


export type AddPatientsByQrMutation = { __typename?: 'Mutation', addPatientsByQR?: { __typename?: 'Patient', id?: string | null, lineId?: string | null, status?: boolean | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type UpdatePatientsMutationVariables = Exact<{
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  access_token: Scalars['String'];
  invitationNumber?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  kana?: InputMaybe<NameUpdateInput>;
  name?: InputMaybe<NameUpdateInput>;
  searchFull?: InputMaybe<Scalars['String']>;
  searchKana?: InputMaybe<Scalars['String']>;
  tel?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePatientsMutation = { __typename?: 'Mutation', updatePatients?: { __typename?: 'Patient', DNumber?: number | null, SNumber?: number | null, age?: number | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, status?: boolean | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type UpdatePatientsByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  address?: InputMaybe<AddressUpdateInput>;
  age?: InputMaybe<Scalars['Int']>;
  birthday?: InputMaybe<Scalars['AWSTimestamp']>;
  comment?: InputMaybe<Scalars['String']>;
  DNumber?: InputMaybe<Scalars['Int']>;
  SNumber?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  invitationNumber?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  kana?: InputMaybe<NameUpdateInput>;
  name?: InputMaybe<NameUpdateInput>;
  searchFull?: InputMaybe<Scalars['String']>;
  searchKana?: InputMaybe<Scalars['String']>;
  tel?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePatientsByIdMutation = { __typename?: 'Mutation', updatePatientsById?: { __typename?: 'Patient', DNumber?: number | null, SNumber?: number | null, age?: number | null, id?: string | null, birthday?: number | null, comment?: string | null, email?: string | null, gender?: string | null, group?: string | null, invitationNumber?: string | null, remarks?: string | null, searchName?: string | null, searchFull?: string | null, searchKana?: string | null, tel?: string | null, status?: boolean | null, address?: { __typename?: 'address', house?: string | null, post?: string | null, prefectures?: string | null } | null, kana?: { __typename?: 'Name', first?: string | null, last?: string | null } | null, name?: { __typename?: 'Name', first?: string | null, last?: string | null } | null } | null };

export type DeletePatientsByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePatientsByIdMutation = { __typename?: 'Mutation', deletePatientsById: { __typename?: 'Patient', id?: string | null, status?: boolean | null } };

export type GetFormQueryVariables = Exact<{
  access_token: Scalars['String'];
}>;


export type GetFormQuery = { __typename?: 'Query', getForm?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null, commentQ3?: string | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } | null };

export type GetCommonFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCommonFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } } | null };

export type GetMedicalFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMedicalFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selectedQ3?: Array<string | null> | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', commentQ4?: string | null, constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null } | null };

export type GetDentalFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDentalFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null } | null };

export type GetOrthodonticsFormByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrthodonticsFormByIdQuery = { __typename?: 'Query', getFormById?: { __typename?: 'Form', orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null } | null } | null };

export type AddCommonFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  common: CommonInput;
}>;


export type AddCommonFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, dateQ6?: string | null, commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } } };

export type AddCommonFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  common: CommonInput;
}>;


export type AddCommonFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, dateQ6?: string | null, commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } } };

export type AddDentalFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  dental: DentalInput;
}>;


export type AddDentalFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null } };

export type AddDentalFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  dental: DentalInput;
}>;


export type AddDentalFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null } };

export type AddMedicalFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  medical: MedicalInput;
}>;


export type AddMedicalFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null } };

export type AddMedicalFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  medical: MedicalInput;
}>;


export type AddMedicalFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null } };

export type AddOrthodonticsFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  orthodontics: OrthodonticsInput;
}>;


export type AddOrthodonticsFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null } | null } };

export type AddOrthodonticsFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  orthodontics: OrthodonticsInput;
}>;


export type AddOrthodonticsFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null } | null } };

export type AddFormMutationVariables = Exact<{
  access_token: Scalars['String'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
}>;


export type AddFormMutation = { __typename?: 'Mutation', addForm: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } };

export type AddFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  common?: InputMaybe<CommonInput>;
  dental?: InputMaybe<DentalInput>;
  medical?: InputMaybe<MedicalInput>;
  orthodontics?: InputMaybe<OrthodonticsInput>;
}>;


export type AddFormByIdMutation = { __typename?: 'Mutation', addFormById: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } };

export type DeleteFormMutationVariables = Exact<{
  access_token: Scalars['String'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', deleteForm?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selectedQ3?: Array<string | null> | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', commentQ4?: string | null, constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', commentQ7?: string | null, selectedQ7?: Array<string | null> | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } | null };

export type DeleteFormByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFormByIdMutation = { __typename?: 'Mutation', deleteFormById?: { __typename?: 'Form', common: { __typename?: 'Common', Q1?: { __typename?: 'commonQ1', answerQ1?: string | null, diseaseQ1: string, selected_clinicQ1?: string | null, selected_medicineQ1?: string | null } | null, Q2?: { __typename?: 'commonQ2', answerQ2?: string | null, commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'commonQ3', answerQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'commonQ4', answerQ4?: string | null, selectedQ4?: Array<string | null> | null, selected_optionsQ4?: string | null } | null, Q5?: { __typename?: 'commonQ5', answerQ5?: string | null } | null, Q6?: { __typename?: 'commonQ6', answerQ6?: string | null, commentQ6?: string | null, dateQ6?: string | null, selectedQ6?: Array<string | null> | null } | null }, dental?: { __typename?: 'Dental', Q1?: { __typename?: 'dentalQ1', commentQ1?: string | null, dateQ1?: number | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'dentalQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'dentalQ3', answerQ3?: string | null, commentQ3?: string | null, selectedQ3?: Array<string | null> | null } | null, Q4?: { __typename?: 'dentalQ4', selectedQ4?: Array<string | null> | null } | null, Q5?: { __typename?: 'dentalQ5', selectedQ5?: Array<string | null> | null } | null } | null, medical?: { __typename?: 'Medical', Q1?: { __typename?: 'medicalQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q2?: { __typename?: 'medicalQ2', bodyQ2?: Array<string | null> | null, commentQ2: string, faceQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'medicalQ3', answerQ3?: string | null, clinic_anotherQ3?: string | null, clinic_otherQ3?: string | null, clinic_salonQ3?: string | null, selectedQ3?: Array<string | null> | null, selected_fatDissolvingQ3?: string | null, selected_laserQ3?: string | null, selected_peelingQ3?: string | null } | null, Q4?: { __typename?: 'medicalQ4', commentQ4?: string | null, constipationQ4?: string | null, favoriteQ4: string, selectedQ4?: Array<string | null> | null, sleepQ4?: string | null, stomachQ4?: string | null, ultravioletRaysQ4?: string | null } | null, Q5?: { __typename?: 'medicalQ5', doctorsCosmeQ5?: string | null, selectedQ5?: Array<string | null> | null, skincareItemQ5?: string | null } | null, Q6?: { __typename?: 'medicalQ6', commentQ6?: string | null, selectedQ6?: Array<string | null> | null } | null } | null, orthodontics?: { __typename?: 'Orthodontics', Q1?: { __typename?: 'orthodonticsQ1', commentQ1?: string | null, selectedQ1?: Array<string | null> | null } | null, Q10?: { __typename?: 'orthodonticsQ10', commentQ10?: string | null, selectedQ10?: Array<string | null> | null } | null, Q2?: { __typename?: 'orthodonticsQ2', commentQ2?: string | null, selectedQ2?: Array<string | null> | null } | null, Q3?: { __typename?: 'orthodonticsQ3', answerQ3?: string | null, commentQ3?: string | null, dateQ3?: number | null } | null, Q4?: { __typename?: 'orthodonticsQ4', answerQ4?: string | null, dateQ4?: number | null } | null, Q5?: { __typename?: 'orthodonticsQ5', commentQ5?: string | null, dateQ5?: number | null, selectedQ5?: Array<string | null> | null } | null, Q6?: { __typename?: 'orthodonticsQ6', selectedQ6?: Array<string | null> | null } | null, Q7?: { __typename?: 'orthodonticsQ7', selectedQ7?: Array<string | null> | null, commentQ7?: string | null } | null, Q8?: { __typename?: 'orthodonticsQ8', answerQ8?: string | null } | null, Q9?: { __typename?: 'orthodonticsQ9', selectedQ9?: Array<string | null> | null } | null } | null } | null };

export type GetRolesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null } };

export type ListRolesQueryVariables = Exact<{
  clinic_id: Scalars['ID'];
}>;


export type ListRolesQuery = { __typename?: 'Query', listRoles: { __typename?: 'Roles', Roles: Array<{ __typename?: 'Role', id: string, name: string, status?: boolean | null, clinic_id?: string | null }> } };

export type AddRolesMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  clinic_id: Scalars['ID'];
}>;


export type AddRolesMutation = { __typename?: 'Mutation', addRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null, clinic_id?: string | null } };

export type DeleteRolesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRolesMutation = { __typename?: 'Mutation', deleteRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null } };

export type UpdateRolesMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateRolesMutation = { __typename?: 'Mutation', updateRoles: { __typename?: 'Role', id: string, name: string, status?: boolean | null } };

export type GetShiftQueryVariables = Exact<{
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
}>;


export type GetShiftQuery = { __typename?: 'Query', getShift: { __typename?: 'Shift', id: string, date: number, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } };

export type GetTodayShiftQueryVariables = Exact<{
  date: Scalars['AWSTimestamp'];
}>;


export type GetTodayShiftQuery = { __typename?: 'Query', getTodayShift: { __typename?: 'Shifts', Shifts: Array<{ __typename?: 'Shift', date: number, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null> } };

export type GetWeeklyShiftQueryVariables = Exact<{
  id: Scalars['ID'];
  weekStart: Scalars['AWSTimestamp'];
  weekEnd: Scalars['AWSTimestamp'];
}>;


export type GetWeeklyShiftQuery = { __typename?: 'Query', getWeeklyShift: { __typename?: 'Shifts', Shifts: Array<{ __typename?: 'Shift', date: number, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null> } };

export type ListShiftQueryVariables = Exact<{ [key: string]: never; }>;


export type ListShiftQuery = { __typename?: 'Query', listShift: { __typename?: 'Shifts', Shifts: Array<{ __typename?: 'Shift', date: number, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null> } };

export type AddShiftMutationVariables = Exact<{
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']> | Scalars['Boolean'];
  workingTimes: WorkingTimesInput;
}>;


export type AddShiftMutation = { __typename?: 'Mutation', addShift: { __typename?: 'Shift', date: number, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', pm: Array<string | null>, am: Array<string | null> } } };

export type BatchWriteShiftMutationVariables = Exact<{
  dates: Array<Scalars['AWSTimestamp']> | Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shifts: Array<Scalars['Boolean']> | Scalars['Boolean'];
  workingTimes: WorkingTimesInput;
}>;


export type BatchWriteShiftMutation = { __typename?: 'Mutation', batchWriteShift?: { __typename?: 'Shift', date: number, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } | null };

export type DeleteShiftMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
}>;


export type DeleteShiftMutation = { __typename?: 'Mutation', deleteShift: { __typename?: 'Shift', date: number, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } };

export type UpdateShiftMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  name?: InputMaybe<Scalars['String']>;
  shifts?: InputMaybe<Array<Scalars['Boolean']> | Scalars['Boolean']>;
  workingTime?: InputMaybe<WorkingTimesInput>;
}>;


export type UpdateShiftMutation = { __typename?: 'Mutation', updateShift: { __typename?: 'Shift', date: number, id: string, name: string, shifts: Array<boolean>, workingTimes: { __typename?: 'workingTimesType', am: Array<string | null>, pm: Array<string | null> } } };


export const GetPhrInfoDocument = `
    query getPHRInfo($access_token: String!, $startTime: AWSTimestamp!) {
  getPHRInfo(access_token: $access_token, startTime: $startTime) {
    date
    expires_at
    buying {
      items {
        count
        name
        price
      }
    }
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
    payment {
      courpon
      method
      price
      ticket {
        buy_at
        counts {
          current
          max
        }
        expires_at
        id
        name
        price
      }
    }
    phr {
      complement
      links {
        name
        url
      }
      progress {
        count
        text
      }
      related
    }
  }
}
    `;
export const useGetPhrInfoQuery = <
      TData = GetPhrInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPhrInfoQueryVariables,
      options?: UseQueryOptions<GetPhrInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPhrInfoQuery, TError, TData>(
      ['getPHRInfo', variables],
      fetcher<GetPhrInfoQuery, GetPhrInfoQueryVariables>(client, GetPhrInfoDocument, variables, headers),
      options
    );
export const GetPhrInfoByIdDocument = `
    query getPHRInfoById($id: ID!, $startTime: AWSTimestamp!) {
  getPHRInfoById(id: $id, startTime: $startTime) {
    date
    id
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
    phr {
      complement
      links {
        name
        url
      }
      progress {
        count
        text
      }
      related
    }
    payment {
      courpon
      method
      price
    }
  }
}
    `;
export const useGetPhrInfoByIdQuery = <
      TData = GetPhrInfoByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPhrInfoByIdQueryVariables,
      options?: UseQueryOptions<GetPhrInfoByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPhrInfoByIdQuery, TError, TData>(
      ['getPHRInfoById', variables],
      fetcher<GetPhrInfoByIdQuery, GetPhrInfoByIdQueryVariables>(client, GetPhrInfoByIdDocument, variables, headers),
      options
    );
export const ListPeriodPhrInfoDocument = `
    query listPeriodPHRInfo($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodPHRInfo(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    PHRInfos {
      buying {
        items {
          count
          name
          price
        }
      }
      confirmed {
        cancel {
          cancelReason
          isCancel
          radioCancelReason
        }
        cancelTime
        consultationTime
        endTime
        menuId
        parts
        receptionTime
        staffIds {
          id
          index
        }
        startTime
        type
      }
      date
      expires_at
      id
      payment {
        courpon
        method
        price
        ticket {
          buy_at
          counts {
            current
            max
          }
          expires_at
          id
          name
          price
        }
      }
      phr {
        complement
        links {
          name
          url
        }
        progress {
          count
          text
        }
        related
      }
    }
  }
}
    `;
export const useListPeriodPhrInfoQuery = <
      TData = ListPeriodPhrInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodPhrInfoQueryVariables,
      options?: UseQueryOptions<ListPeriodPhrInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodPhrInfoQuery, TError, TData>(
      ['listPeriodPHRInfo', variables],
      fetcher<ListPeriodPhrInfoQuery, ListPeriodPhrInfoQueryVariables>(client, ListPeriodPhrInfoDocument, variables, headers),
      options
    );
export const ListPeriodPhrInfoByIdDocument = `
    query listPeriodPHRInfoById($id: ID!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodPHRInfoById(endDate: $endDate, id: $id, startDate: $startDate) {
    PHRInfos {
      confirmed {
        cancel {
          cancelReason
          isCancel
          radioCancelReason
        }
        cancelTime
        consultationTime
        endTime
        menuId
        parts
        receptionTime
        staffIds {
          id
          index
        }
        startTime
        type
      }
      phr {
        progress {
          count
        }
      }
    }
  }
}
    `;
export const useListPeriodPhrInfoByIdQuery = <
      TData = ListPeriodPhrInfoByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodPhrInfoByIdQueryVariables,
      options?: UseQueryOptions<ListPeriodPhrInfoByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodPhrInfoByIdQuery, TError, TData>(
      ['listPeriodPHRInfoById', variables],
      fetcher<ListPeriodPhrInfoByIdQuery, ListPeriodPhrInfoByIdQueryVariables>(client, ListPeriodPhrInfoByIdDocument, variables, headers),
      options
    );
export const ListPeriodPhrInfoConfirmedDocument = `
    query listPeriodPHRInfoConfirmed($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodPHRInfo(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    PHRInfos {
      id
      confirmed {
        cancel {
          cancelReason
          isCancel
          radioCancelReason
        }
        cancelTime
        consultationTime
        endTime
        menuId
        parts
        receptionTime
        staffIds {
          id
          index
        }
        startTime
        type
      }
    }
  }
}
    `;
export const useListPeriodPhrInfoConfirmedQuery = <
      TData = ListPeriodPhrInfoConfirmedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodPhrInfoConfirmedQueryVariables,
      options?: UseQueryOptions<ListPeriodPhrInfoConfirmedQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodPhrInfoConfirmedQuery, TError, TData>(
      ['listPeriodPHRInfoConfirmed', variables],
      fetcher<ListPeriodPhrInfoConfirmedQuery, ListPeriodPhrInfoConfirmedQueryVariables>(client, ListPeriodPhrInfoConfirmedDocument, variables, headers),
      options
    );
export const AddPhrInfoDocument = `
    mutation addPHRInfo($PHRInfoInput: PHRInfoInput!) {
  addPHRInfo(PHRInfoInput: $PHRInfoInput) {
    buying {
      items {
        count
        name
        price
      }
    }
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
    date
    expires_at
    id
    payment {
      courpon
      method
      price
      ticket {
        buy_at
        counts {
          current
          max
        }
        expires_at
        id
        name
        price
      }
    }
    phr {
      complement
      links {
        name
        url
      }
      progress {
        count
        text
      }
      related
    }
  }
}
    `;
export const useAddPhrInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPhrInfoMutation, TError, AddPhrInfoMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddPhrInfoMutation, TError, AddPhrInfoMutationVariables, TContext>(
      ['addPHRInfo'],
      (variables?: AddPhrInfoMutationVariables) => fetcher<AddPhrInfoMutation, AddPhrInfoMutationVariables>(client, AddPhrInfoDocument, variables, headers)(),
      options
    );
export const GetPhrInfoConfirmedDocument = `
    query getPHRInfoConfirmed($access_token: String!, $date: AWSTimestamp!) {
  getPHRInfo(access_token: $access_token, startTime: $date) {
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
  }
}
    `;
export const useGetPhrInfoConfirmedQuery = <
      TData = GetPhrInfoConfirmedQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPhrInfoConfirmedQueryVariables,
      options?: UseQueryOptions<GetPhrInfoConfirmedQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPhrInfoConfirmedQuery, TError, TData>(
      ['getPHRInfoConfirmed', variables],
      fetcher<GetPhrInfoConfirmedQuery, GetPhrInfoConfirmedQueryVariables>(client, GetPhrInfoConfirmedDocument, variables, headers),
      options
    );
export const DeletePhrInfoConfirmedDocument = `
    mutation deletePHRInfoConfirmed($id: ID!, $date: AWSTimestamp!) {
  deletePHRInfoConfirmed(date: $date, id: $id) {
    confirmed {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      consultationTime
      endTime
      menuId
      parts
      receptionTime
      staffIds {
        id
        index
      }
      startTime
      type
    }
  }
}
    `;
export const useDeletePhrInfoConfirmedMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePhrInfoConfirmedMutation, TError, DeletePhrInfoConfirmedMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePhrInfoConfirmedMutation, TError, DeletePhrInfoConfirmedMutationVariables, TContext>(
      ['deletePHRInfoConfirmed'],
      (variables?: DeletePhrInfoConfirmedMutationVariables) => fetcher<DeletePhrInfoConfirmedMutation, DeletePhrInfoConfirmedMutationVariables>(client, DeletePhrInfoConfirmedDocument, variables, headers)(),
      options
    );
export const ScanPeriodBlockDocument = `
    query scanPeriodBlock($startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $clinic_id: ID!) {
  scanPeriodBlock(startTime: $startTime, endTime: $endTime, clinic_id: $clinic_id) {
    AppointBlocks {
      id
      startTime
      endTime
      facilityId
      remarks
      color
      isNonAccepted
      isDelete
      clinic_id
    }
  }
}
    `;
export const useScanPeriodBlockQuery = <
      TData = ScanPeriodBlockQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ScanPeriodBlockQueryVariables,
      options?: UseQueryOptions<ScanPeriodBlockQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ScanPeriodBlockQuery, TError, TData>(
      ['scanPeriodBlock', variables],
      fetcher<ScanPeriodBlockQuery, ScanPeriodBlockQueryVariables>(client, ScanPeriodBlockDocument, variables, headers),
      options
    );
export const AddBlockDocument = `
    mutation addBlock($startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $facilityId: ID!, $remarks: String, $color: String, $clinic_id: ID!) {
  addBlock(startTime: $startTime, endTime: $endTime, facilityId: $facilityId, remarks: $remarks, color: $color, clinic_id: $clinic_id) {
    id
    startTime
    endTime
    facilityId
    remarks
    isNonAccepted
    isDelete
    clinic_id
  }
}
    `;
export const useAddBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddBlockMutation, TError, AddBlockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddBlockMutation, TError, AddBlockMutationVariables, TContext>(
      ['addBlock'],
      (variables?: AddBlockMutationVariables) => fetcher<AddBlockMutation, AddBlockMutationVariables>(client, AddBlockDocument, variables, headers)(),
      options
    );
export const UpdateBlockDocument = `
    mutation updateBlock($baseId: ID!, $baseStartTime: AWSTimestamp!, $id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $facilityId: ID!, $remarks: String, $color: String, $clinic_id: ID!) {
  updateBlock(baseId: $baseId, baseStartTime: $baseStartTime, id: $id, startTime: $startTime, endTime: $endTime, facilityId: $facilityId, remarks: $remarks, color: $color, clinic_id: $clinic_id) {
    id
    startTime
    endTime
    facilityId
    remarks
    isNonAccepted
    isDelete
    clinic_id
  }
}
    `;
export const useUpdateBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateBlockMutation, TError, UpdateBlockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateBlockMutation, TError, UpdateBlockMutationVariables, TContext>(
      ['updateBlock'],
      (variables?: UpdateBlockMutationVariables) => fetcher<UpdateBlockMutation, UpdateBlockMutationVariables>(client, UpdateBlockDocument, variables, headers)(),
      options
    );
export const UpdateBlockStatusDocument = `
    mutation updateBlockStatus($id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $facilityId: ID!, $remarks: String, $color: String) {
  updateBlockStatus(id: $id, startTime: $startTime, endTime: $endTime, facilityId: $facilityId, remarks: $remarks, color: $color) {
    id
    startTime
    endTime
    facilityId
    remarks
    isNonAccepted
    isDelete
  }
}
    `;
export const useUpdateBlockStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateBlockStatusMutation, TError, UpdateBlockStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateBlockStatusMutation, TError, UpdateBlockStatusMutationVariables, TContext>(
      ['updateBlockStatus'],
      (variables?: UpdateBlockStatusMutationVariables) => fetcher<UpdateBlockStatusMutation, UpdateBlockStatusMutationVariables>(client, UpdateBlockStatusDocument, variables, headers)(),
      options
    );
export const DeleteBlockDocument = `
    mutation deleteBlock($id: ID!, $startTime: AWSTimestamp!) {
  deleteBlock(id: $id, startTime: $startTime) {
    id
    startTime
    endTime
    facilityId
    remarks
    color
    isNonAccepted
    isDelete
  }
}
    `;
export const useDeleteBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteBlockMutation, TError, DeleteBlockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteBlockMutation, TError, DeleteBlockMutationVariables, TContext>(
      ['deleteBlock'],
      (variables?: DeleteBlockMutationVariables) => fetcher<DeleteBlockMutation, DeleteBlockMutationVariables>(client, DeleteBlockDocument, variables, headers)(),
      options
    );
export const GetBlockDocument = `
    query getBlock($id: ID!, $startTime: AWSTimestamp!) {
  getBlock(id: $id, startTime: $startTime) {
    id
    startTime
    endTime
    facilityId
    remarks
    color
    isNonAccepted
    isDelete
  }
}
    `;
export const useGetBlockQuery = <
      TData = GetBlockQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBlockQueryVariables,
      options?: UseQueryOptions<GetBlockQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetBlockQuery, TError, TData>(
      ['getBlock', variables],
      fetcher<GetBlockQuery, GetBlockQueryVariables>(client, GetBlockDocument, variables, headers),
      options
    );
export const CheckDubbleBookingDocument = `
    mutation checkDubbleBooking($id: ID!, $date: AWSTimestamp!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!) {
  checkDubbleBooking(id: $id, date: $date, startTime: $startTime, endTime: $endTime) {
    isDubbleBooking
  }
}
    `;
export const useCheckDubbleBookingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckDubbleBookingMutation, TError, CheckDubbleBookingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckDubbleBookingMutation, TError, CheckDubbleBookingMutationVariables, TContext>(
      ['checkDubbleBooking'],
      (variables?: CheckDubbleBookingMutationVariables) => fetcher<CheckDubbleBookingMutation, CheckDubbleBookingMutationVariables>(client, CheckDubbleBookingDocument, variables, headers)(),
      options
    );
export const ChangeStatusDocument = `
    mutation changeStatus($appoint: String!, $id: ID!, $startTime: AWSTimestamp!, $receptionTime: AWSTimestamp, $cancelTime: AWSTimestamp, $consultationTime: AWSTimestamp, $cancel: CancelInput) {
  changeStatus(appoint: $appoint, id: $id, startTime: $startTime, receptionTime: $receptionTime, consultationTime: $consultationTime, cancelTime: $cancelTime, cancel: $cancel) {
    appoint
    id
    startTime
    receptionTime
    consultationTime
    cancelTime
    cancel {
      isCancel
      cancelReason
      radioCancelReason
    }
    created_at
    updated_at
  }
}
    `;
export const useChangeStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeStatusMutation, TError, ChangeStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeStatusMutation, TError, ChangeStatusMutationVariables, TContext>(
      ['changeStatus'],
      (variables?: ChangeStatusMutationVariables) => fetcher<ChangeStatusMutation, ChangeStatusMutationVariables>(client, ChangeStatusDocument, variables, headers)(),
      options
    );
export const AddAppointDocument = `
    mutation addAppoint($id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp!, $date: AWSTimestamp!, $appoint: String, $appointId: ID, $type: String!, $menuId: String!, $facilityId: String!, $price: Int!, $staffIds: [StaffIdInput], $secondStartTime: AWSTimestamp, $secondEndTime: AWSTimestamp, $thirdStartTime: AWSTimestamp, $thirdEndTime: AWSTimestamp, $confirmedTime: AWSTimestamp, $confirmedEndTime: AWSTimestamp, $remarks: String, $isFirstVisiting: Boolean, $clinic_id: ID!) {
  addAppoint(id: $id, appointId: $appointId, startTime: $startTime, endTime: $endTime, date: $date, appoint: $appoint, type: $type, menuId: $menuId, facilityId: $facilityId, price: $price, staffIds: $staffIds, secondStartTime: $secondStartTime, secondEndTime: $secondEndTime, thirdStartTime: $thirdStartTime, thirdEndTime: $thirdEndTime, confirmedTime: $confirmedTime, confirmedEndTime: $confirmedEndTime, remarks: $remarks, isFirstVisiting: $isFirstVisiting, clinic_id: $clinic_id) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    isDubbleBooking
    created_at
    updated_at
    clinic_id
  }
}
    `;
export const useAddAppointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddAppointMutation, TError, AddAppointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddAppointMutation, TError, AddAppointMutationVariables, TContext>(
      ['addAppoint'],
      (variables?: AddAppointMutationVariables) => fetcher<AddAppointMutation, AddAppointMutationVariables>(client, AddAppointDocument, variables, headers)(),
      options
    );
export const DeleteAppointDocument = `
    mutation deleteAppoint($id: ID!, $startTime: AWSTimestamp!) {
  deleteAppoint(id: $id, startTime: $startTime) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    created_at
    updated_at
  }
}
    `;
export const useDeleteAppointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAppointMutation, TError, DeleteAppointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteAppointMutation, TError, DeleteAppointMutationVariables, TContext>(
      ['deleteAppoint'],
      (variables?: DeleteAppointMutationVariables) => fetcher<DeleteAppointMutation, DeleteAppointMutationVariables>(client, DeleteAppointDocument, variables, headers)(),
      options
    );
export const UpdateAppointDocument = `
    mutation updateAppoint($baseId: ID!, $baseStartTime: AWSTimestamp!, $id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp, $appoint: String, $appointId: ID!, $type: String, $staffIds: [StaffIdInput], $menuId: String, $facilityId: String, $price: Int, $secondStartTime: AWSTimestamp, $secondEndTime: AWSTimestamp, $thirdStartTime: AWSTimestamp, $thirdEndTime: AWSTimestamp, $confirmedTime: AWSTimestamp, $confirmedEndTime: AWSTimestamp, $remarks: String, $isFirstVisiting: Boolean, $date: AWSTimestamp!, $clinic_id: ID!) {
  updateAppoint(baseId: $baseId, baseStartTime: $baseStartTime, id: $id, startTime: $startTime, endTime: $endTime, appoint: $appoint, appointId: $appointId, type: $type, staffIds: $staffIds, menuId: $menuId, facilityId: $facilityId, price: $price, secondStartTime: $secondStartTime, secondEndTime: $secondEndTime, thirdStartTime: $thirdStartTime, thirdEndTime: $thirdEndTime, confirmedTime: $confirmedTime, confirmedEndTime: $confirmedEndTime, remarks: $remarks, isFirstVisiting: $isFirstVisiting, date: $date, clinic_id: $clinic_id) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    isDubbleBooking
    created_at
    updated_at
    clinic_id
  }
}
    `;
export const useUpdateAppointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAppointMutation, TError, UpdateAppointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAppointMutation, TError, UpdateAppointMutationVariables, TContext>(
      ['updateAppoint'],
      (variables?: UpdateAppointMutationVariables) => fetcher<UpdateAppointMutation, UpdateAppointMutationVariables>(client, UpdateAppointDocument, variables, headers)(),
      options
    );
export const UpdateAppointInfoDocument = `
    mutation updateAppointInfo($id: ID!, $startTime: AWSTimestamp!, $endTime: AWSTimestamp, $appoint: String, $type: String, $staffIds: [StaffIdInput], $menuId: String, $facilityId: String, $price: Int, $secondStartTime: AWSTimestamp, $secondEndTime: AWSTimestamp, $thirdStartTime: AWSTimestamp, $thirdEndTime: AWSTimestamp, $confirmedTime: AWSTimestamp, $confirmedEndTime: AWSTimestamp, $remarks: String, $isFirstVisiting: Boolean, $date: AWSTimestamp!) {
  updateAppointInfo(id: $id, startTime: $startTime, endTime: $endTime, appoint: $appoint, type: $type, staffIds: $staffIds, menuId: $menuId, facilityId: $facilityId, price: $price, secondStartTime: $secondStartTime, secondEndTime: $secondEndTime, thirdStartTime: $thirdStartTime, thirdEndTime: $thirdEndTime, confirmedTime: $confirmedTime, confirmedEndTime: $confirmedEndTime, remarks: $remarks, isFirstVisiting: $isFirstVisiting, date: $date) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    created_at
    updated_at
  }
}
    `;
export const useUpdateAppointInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAppointInfoMutation, TError, UpdateAppointInfoMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAppointInfoMutation, TError, UpdateAppointInfoMutationVariables, TContext>(
      ['updateAppointInfo'],
      (variables?: UpdateAppointInfoMutationVariables) => fetcher<UpdateAppointInfoMutation, UpdateAppointInfoMutationVariables>(client, UpdateAppointInfoDocument, variables, headers)(),
      options
    );
export const GetAppointDocument = `
    query getAppoint($id: ID!, $startTime: AWSTimestamp!) {
  getAppoint(id: $id, startTime: $startTime) {
    appoint
    appointId
    cancel {
      cancelReason
      isCancel
      radioCancelReason
    }
    cancelTime
    confirmedEndTime
    confirmedTime
    consultationTime
    date
    endTime
    facilityId
    id
    isFirstVisiting
    menuId
    price
    receptionTime
    remarks
    secondEndTime
    secondStartTime
    staffIds {
      id
      index
    }
    startTime
    thirdEndTime
    thirdStartTime
    type
    created_at
    updated_at
  }
}
    `;
export const useGetAppointQuery = <
      TData = GetAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAppointQueryVariables,
      options?: UseQueryOptions<GetAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAppointQuery, TError, TData>(
      ['getAppoint', variables],
      fetcher<GetAppointQuery, GetAppointQueryVariables>(client, GetAppointDocument, variables, headers),
      options
    );
export const GetTodayAppointDocument = `
    query getTodayAppoint($date: AWSTimestamp!, $id: ID!, $choice: Int) {
  getTodayAppoint(date: $date, id: $id, choice: $choice) {
    Appoints {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      appointId
      appoint
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
    }
  }
}
    `;
export const useGetTodayAppointQuery = <
      TData = GetTodayAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTodayAppointQueryVariables,
      options?: UseQueryOptions<GetTodayAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTodayAppointQuery, TError, TData>(
      ['getTodayAppoint', variables],
      fetcher<GetTodayAppointQuery, GetTodayAppointQueryVariables>(client, GetTodayAppointDocument, variables, headers),
      options
    );
export const ListPeriodAppointDocument = `
    query listPeriodAppoint($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodAppoint(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    Appoints {
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      appointId
      appoint
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
    }
  }
}
    `;
export const useListPeriodAppointQuery = <
      TData = ListPeriodAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodAppointQueryVariables,
      options?: UseQueryOptions<ListPeriodAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodAppointQuery, TError, TData>(
      ['listPeriodAppoint', variables],
      fetcher<ListPeriodAppointQuery, ListPeriodAppointQueryVariables>(client, ListPeriodAppointDocument, variables, headers),
      options
    );
export const ListPeriodAppointByIdDocument = `
    query listPeriodAppointById($id: ID!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodAppointById(endDate: $endDate, id: $id, startDate: $startDate) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
    }
  }
}
    `;
export const useListPeriodAppointByIdQuery = <
      TData = ListPeriodAppointByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodAppointByIdQueryVariables,
      options?: UseQueryOptions<ListPeriodAppointByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodAppointByIdQuery, TError, TData>(
      ['listPeriodAppointById', variables],
      fetcher<ListPeriodAppointByIdQuery, ListPeriodAppointByIdQueryVariables>(client, ListPeriodAppointByIdDocument, variables, headers),
      options
    );
export const ListAppointByIdDocument = `
    query listAppointById($id: ID!) {
  listAppointById(id: $id) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
    }
  }
}
    `;
export const useListAppointByIdQuery = <
      TData = ListAppointByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListAppointByIdQueryVariables,
      options?: UseQueryOptions<ListAppointByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListAppointByIdQuery, TError, TData>(
      ['listAppointById', variables],
      fetcher<ListAppointByIdQuery, ListAppointByIdQueryVariables>(client, ListAppointByIdDocument, variables, headers),
      options
    );
export const ListTodayAppointDocument = `
    query listTodayAppoint($date: AWSTimestamp!, $choice: Int) {
  listTodayAppoint(date: $date, choice: $choice) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      secondEndTime
      secondStartTime
      staffIds {
        id
        index
      }
      startTime
      thirdEndTime
      thirdStartTime
      type
      created_at
      updated_at
    }
  }
}
    `;
export const useListTodayAppointQuery = <
      TData = ListTodayAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListTodayAppointQueryVariables,
      options?: UseQueryOptions<ListTodayAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListTodayAppointQuery, TError, TData>(
      ['listTodayAppoint', variables],
      fetcher<ListTodayAppointQuery, ListTodayAppointQueryVariables>(client, ListTodayAppointDocument, variables, headers),
      options
    );
export const ScanPeriodAppointDocument = `
    query scanPeriodAppoint($startDate: AWSTimestamp!, $endDate: AWSTimestamp!, $clinic_id: ID!) {
  scanPeriodAppoint(endDate: $endDate, startDate: $startDate, clinic_id: $clinic_id) {
    Appoints {
      appoint
      appointId
      cancel {
        cancelReason
        isCancel
        radioCancelReason
      }
      cancelTime
      confirmedEndTime
      confirmedTime
      consultationTime
      date
      endTime
      facilityId
      id
      isFirstVisiting
      menuId
      price
      receptionTime
      remarks
      staffIds {
        id
        index
      }
      startTime
      type
      created_at
      updated_at
      clinic_id
    }
  }
}
    `;
export const useScanPeriodAppointQuery = <
      TData = ScanPeriodAppointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ScanPeriodAppointQueryVariables,
      options?: UseQueryOptions<ScanPeriodAppointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ScanPeriodAppointQuery, TError, TData>(
      ['scanPeriodAppoint', variables],
      fetcher<ScanPeriodAppointQuery, ScanPeriodAppointQueryVariables>(client, ScanPeriodAppointDocument, variables, headers),
      options
    );
export const CheckLastUpdateDocument = `
    query checkLastUpdate($id: ID!, $startTime: AWSTimestamp!, $beforeUpdated_at: AWSTimestamp!, $appointId: ID!) {
  checkLastUpdate(id: $id, startTime: $startTime, beforeUpdated_at: $beforeUpdated_at, appointId: $appointId) {
    id
    startTime
    appointId
    created_at
    updated_at
    isUpdated
  }
}
    `;
export const useCheckLastUpdateQuery = <
      TData = CheckLastUpdateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckLastUpdateQueryVariables,
      options?: UseQueryOptions<CheckLastUpdateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckLastUpdateQuery, TError, TData>(
      ['checkLastUpdate', variables],
      fetcher<CheckLastUpdateQuery, CheckLastUpdateQueryVariables>(client, CheckLastUpdateDocument, variables, headers),
      options
    );
export const GetClinicDocument = `
    query getClinic($org_id: ID!, $clinic_id: ID!) {
  getClinic(org_id: $org_id, clinic_id: $clinic_id) {
    org_id
    clinic_id
    clinic_label
    clinic_name
    isDelete
    created_at
    updated_at
  }
}
    `;
export const useGetClinicQuery = <
      TData = GetClinicQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClinicQueryVariables,
      options?: UseQueryOptions<GetClinicQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicQuery, TError, TData>(
      ['getClinic', variables],
      fetcher<GetClinicQuery, GetClinicQueryVariables>(client, GetClinicDocument, variables, headers),
      options
    );
export const GetClinicLabelDocument = `
    query getClinicLabel($org_id: ID!, $clinic_id: ID!) {
  getClinic(org_id: $org_id, clinic_id: $clinic_id) {
    clinic_label
  }
}
    `;
export const useGetClinicLabelQuery = <
      TData = GetClinicLabelQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClinicLabelQueryVariables,
      options?: UseQueryOptions<GetClinicLabelQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicLabelQuery, TError, TData>(
      ['getClinicLabel', variables],
      fetcher<GetClinicLabelQuery, GetClinicLabelQueryVariables>(client, GetClinicLabelDocument, variables, headers),
      options
    );
export const ListClinicsDocument = `
    query listClinics {
  listClinics {
    clinics {
      org_id
      clinic_id
      clinic_label
      clinic_name
      isDelete
      created_at
      updated_at
    }
  }
}
    `;
export const useListClinicsQuery = <
      TData = ListClinicsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListClinicsQueryVariables,
      options?: UseQueryOptions<ListClinicsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListClinicsQuery, TError, TData>(
      variables === undefined ? ['listClinics'] : ['listClinics', variables],
      fetcher<ListClinicsQuery, ListClinicsQueryVariables>(client, ListClinicsDocument, variables, headers),
      options
    );
export const GetCommentDocument = `
    query getComment($id: ID!) {
  getComment(id: $id) {
    comment
    id
  }
}
    `;
export const useGetCommentQuery = <
      TData = GetCommentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCommentQueryVariables,
      options?: UseQueryOptions<GetCommentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCommentQuery, TError, TData>(
      ['getComment', variables],
      fetcher<GetCommentQuery, GetCommentQueryVariables>(client, GetCommentDocument, variables, headers),
      options
    );
export const AddCommentDocument = `
    mutation addComment($id: ID!, $comment: String!) {
  addComment(comment: $comment, id: $id) {
    comment
    id
  }
}
    `;
export const useAddCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommentMutation, TError, AddCommentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommentMutation, TError, AddCommentMutationVariables, TContext>(
      ['addComment'],
      (variables?: AddCommentMutationVariables) => fetcher<AddCommentMutation, AddCommentMutationVariables>(client, AddCommentDocument, variables, headers)(),
      options
    );
export const GetCommentsDocument = `
    query getComments($clinic_id: ID!, $date: AWSTimestamp!) {
  getComments(clinic_id: $clinic_id, date: $date) {
    clinic_id
    date
    comment
    commentId
  }
}
    `;
export const useGetCommentsQuery = <
      TData = GetCommentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCommentsQueryVariables,
      options?: UseQueryOptions<GetCommentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCommentsQuery, TError, TData>(
      ['getComments', variables],
      fetcher<GetCommentsQuery, GetCommentsQueryVariables>(client, GetCommentsDocument, variables, headers),
      options
    );
export const AddCommentsDocument = `
    mutation addComments($clinic_id: ID!, $date: AWSTimestamp!, $comment: String!) {
  addComments(clinic_id: $clinic_id, date: $date, comment: $comment) {
    clinic_id
    date
    comment
    commentId
  }
}
    `;
export const useAddCommentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommentsMutation, TError, AddCommentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommentsMutation, TError, AddCommentsMutationVariables, TContext>(
      ['addComments'],
      (variables?: AddCommentsMutationVariables) => fetcher<AddCommentsMutation, AddCommentsMutationVariables>(client, AddCommentsDocument, variables, headers)(),
      options
    );
export const ListFacilitiesDocument = `
    query listFacilities($clinic_id: ID!) {
  listFacilities(clinic_id: $clinic_id) {
    Facilities {
      id
      name
      status
      isDelete
      index
      clinic_id
    }
  }
}
    `;
export const useListFacilitiesQuery = <
      TData = ListFacilitiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFacilitiesQueryVariables,
      options?: UseQueryOptions<ListFacilitiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFacilitiesQuery, TError, TData>(
      ['listFacilities', variables],
      fetcher<ListFacilitiesQuery, ListFacilitiesQueryVariables>(client, ListFacilitiesDocument, variables, headers),
      options
    );
export const ListFacilitieNamesDocument = `
    query listFacilitieNames($clinic_id: ID!) {
  listFacilities(clinic_id: $clinic_id) {
    Facilities {
      id
      name
      isDelete
    }
  }
}
    `;
export const useListFacilitieNamesQuery = <
      TData = ListFacilitieNamesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListFacilitieNamesQueryVariables,
      options?: UseQueryOptions<ListFacilitieNamesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListFacilitieNamesQuery, TError, TData>(
      ['listFacilitieNames', variables],
      fetcher<ListFacilitieNamesQuery, ListFacilitieNamesQueryVariables>(client, ListFacilitieNamesDocument, variables, headers),
      options
    );
export const AddFacilityDocument = `
    mutation addFacility($name: String!, $status: Boolean!, $isDelete: Boolean, $index: Int, $clinic_id: ID!) {
  addFacility(name: $name, status: $status, isDelete: $isDelete, index: $index, clinic_id: $clinic_id) {
    id
    name
    status
    isDelete
    index
    clinic_id
  }
}
    `;
export const useAddFacilityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFacilityMutation, TError, AddFacilityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFacilityMutation, TError, AddFacilityMutationVariables, TContext>(
      ['addFacility'],
      (variables?: AddFacilityMutationVariables) => fetcher<AddFacilityMutation, AddFacilityMutationVariables>(client, AddFacilityDocument, variables, headers)(),
      options
    );
export const DeleteFacilityDocument = `
    mutation deleteFacility($id: ID!) {
  deleteFacility(id: $id) {
    id
    name
    status
    isDelete
    index
  }
}
    `;
export const useDeleteFacilityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFacilityMutation, TError, DeleteFacilityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFacilityMutation, TError, DeleteFacilityMutationVariables, TContext>(
      ['deleteFacility'],
      (variables?: DeleteFacilityMutationVariables) => fetcher<DeleteFacilityMutation, DeleteFacilityMutationVariables>(client, DeleteFacilityDocument, variables, headers)(),
      options
    );
export const UpdateFacilityDocument = `
    mutation updateFacility($id: ID!, $name: String, $status: Boolean, $isDelete: Boolean, $index: Int) {
  updateFacility(id: $id, name: $name, status: $status, isDelete: $isDelete, index: $index) {
    id
    name
    status
    isDelete
    index
  }
}
    `;
export const useUpdateFacilityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFacilityMutation, TError, UpdateFacilityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFacilityMutation, TError, UpdateFacilityMutationVariables, TContext>(
      ['updateFacility'],
      (variables?: UpdateFacilityMutationVariables) => fetcher<UpdateFacilityMutation, UpdateFacilityMutationVariables>(client, UpdateFacilityDocument, variables, headers)(),
      options
    );
export const GetManegerDocument = `
    query getManeger($id: ID!) {
  getManeger(id: $id) {
    id
    role
    name
    rights
    email
    color
    isDelete
    index
  }
}
    `;
export const useGetManegerQuery = <
      TData = GetManegerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetManegerQueryVariables,
      options?: UseQueryOptions<GetManegerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetManegerQuery, TError, TData>(
      ['getManeger', variables],
      fetcher<GetManegerQuery, GetManegerQueryVariables>(client, GetManegerDocument, variables, headers),
      options
    );
export const ListManegerDocument = `
    query listManeger($clinic_id: ID!) {
  listManeger(clinic_id: $clinic_id) {
    Manegers {
      id
      role
      name
      rights
      email
      color
      isDelete
      index
      clinic_id
    }
  }
}
    `;
export const useListManegerQuery = <
      TData = ListManegerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListManegerQueryVariables,
      options?: UseQueryOptions<ListManegerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListManegerQuery, TError, TData>(
      ['listManeger', variables],
      fetcher<ListManegerQuery, ListManegerQueryVariables>(client, ListManegerDocument, variables, headers),
      options
    );
export const ListManegerNameDocument = `
    query listManegerName($clinic_id: ID!) {
  listManeger(clinic_id: $clinic_id) {
    Manegers {
      id
      name
      isDelete
      index
    }
  }
}
    `;
export const useListManegerNameQuery = <
      TData = ListManegerNameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListManegerNameQueryVariables,
      options?: UseQueryOptions<ListManegerNameQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListManegerNameQuery, TError, TData>(
      ['listManegerName', variables],
      fetcher<ListManegerNameQuery, ListManegerNameQueryVariables>(client, ListManegerNameDocument, variables, headers),
      options
    );
export const AddManegerDocument = `
    mutation addManeger($role: String!, $name: String!, $rights: String!, $email: String!, $color: String, $isDelete: Boolean, $index: Int, $clinic_id: ID!) {
  addManeger(role: $role, name: $name, rights: $rights, email: $email, color: $color, isDelete: $isDelete, index: $index, clinic_id: $clinic_id) {
    id
    role
    name
    rights
    email
    color
    isDelete
    index
    clinic_id
  }
}
    `;
export const useAddManegerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddManegerMutation, TError, AddManegerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddManegerMutation, TError, AddManegerMutationVariables, TContext>(
      ['addManeger'],
      (variables?: AddManegerMutationVariables) => fetcher<AddManegerMutation, AddManegerMutationVariables>(client, AddManegerDocument, variables, headers)(),
      options
    );
export const DeleteManegerDocument = `
    mutation deleteManeger($id: ID!) {
  deleteManeger(id: $id) {
    id
    role
    name
    rights
    email
    color
    isDelete
    index
  }
}
    `;
export const useDeleteManegerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteManegerMutation, TError, DeleteManegerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteManegerMutation, TError, DeleteManegerMutationVariables, TContext>(
      ['deleteManeger'],
      (variables?: DeleteManegerMutationVariables) => fetcher<DeleteManegerMutation, DeleteManegerMutationVariables>(client, DeleteManegerDocument, variables, headers)(),
      options
    );
export const UpDateManegerDocument = `
    mutation upDateManeger($id: ID!, $role: String, $name: String, $rights: String, $email: String, $color: String, $isDelete: Boolean, $index: Int) {
  updateManeger(id: $id, role: $role, name: $name, rights: $rights, email: $email, color: $color, isDelete: $isDelete, index: $index) {
    id
    role
    name
    rights
    email
    color
    isDelete
    index
  }
}
    `;
export const useUpDateManegerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpDateManegerMutation, TError, UpDateManegerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpDateManegerMutation, TError, UpDateManegerMutationVariables, TContext>(
      ['upDateManeger'],
      (variables?: UpDateManegerMutationVariables) => fetcher<UpDateManegerMutation, UpDateManegerMutationVariables>(client, UpDateManegerDocument, variables, headers)(),
      options
    );
export const UpdateManegerColorDocument = `
    mutation updateManegerColor($id: ID!, $color: String!) {
  updateManeger(id: $id, color: $color) {
    id
    color
  }
}
    `;
export const useUpdateManegerColorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateManegerColorMutation, TError, UpdateManegerColorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateManegerColorMutation, TError, UpdateManegerColorMutationVariables, TContext>(
      ['updateManegerColor'],
      (variables?: UpdateManegerColorMutationVariables) => fetcher<UpdateManegerColorMutation, UpdateManegerColorMutationVariables>(client, UpdateManegerColorDocument, variables, headers)(),
      options
    );
export const ListCategorysDocument = `
    query listCategorys($clinic_id: ID!) {
  listCategorys(clinic_id: $clinic_id) {
    Categorys {
      id
      isDelete
      mainCategory
      name
      clinic_id
    }
  }
}
    `;
export const useListCategorysQuery = <
      TData = ListCategorysQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListCategorysQueryVariables,
      options?: UseQueryOptions<ListCategorysQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListCategorysQuery, TError, TData>(
      ['listCategorys', variables],
      fetcher<ListCategorysQuery, ListCategorysQueryVariables>(client, ListCategorysDocument, variables, headers),
      options
    );
export const AddCategoryDocument = `
    mutation addCategory($mainCategory: String!, $name: String!, $clinic_id: ID!) {
  addCategory(mainCategory: $mainCategory, name: $name, clinic_id: $clinic_id) {
    id
    isDelete
    mainCategory
    name
    clinic_id
  }
}
    `;
export const useAddCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCategoryMutation, TError, AddCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCategoryMutation, TError, AddCategoryMutationVariables, TContext>(
      ['addCategory'],
      (variables?: AddCategoryMutationVariables) => fetcher<AddCategoryMutation, AddCategoryMutationVariables>(client, AddCategoryDocument, variables, headers)(),
      options
    );
export const DeleteCategoryDocument = `
    mutation deleteCategory($id: ID!) {
  deleteCategory(id: $id) {
    id
    isDelete
    mainCategory
    name
  }
}
    `;
export const useDeleteCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCategoryMutation, TError, DeleteCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCategoryMutation, TError, DeleteCategoryMutationVariables, TContext>(
      ['deleteCategory'],
      (variables?: DeleteCategoryMutationVariables) => fetcher<DeleteCategoryMutation, DeleteCategoryMutationVariables>(client, DeleteCategoryDocument, variables, headers)(),
      options
    );
export const UpdateCategoryDocument = `
    mutation updateCategory($id: ID!, $mainCategory: String, $name: String) {
  updateCategory(id: $id, mainCategory: $mainCategory, name: $name) {
    id
    isDelete
    mainCategory
    name
  }
}
    `;
export const useUpdateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCategoryMutation, TError, UpdateCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCategoryMutation, TError, UpdateCategoryMutationVariables, TContext>(
      ['updateCategory'],
      (variables?: UpdateCategoryMutationVariables) => fetcher<UpdateCategoryMutation, UpdateCategoryMutationVariables>(client, UpdateCategoryDocument, variables, headers)(),
      options
    );
export const TransactDeleteCategorysDocument = `
    mutation transactDeleteCategorys($SDK_IDs: [ID!]!) {
  transactDeleteCategorys(SDK_IDs: $SDK_IDs) {
    TransactReturn
  }
}
    `;
export const useTransactDeleteCategorysMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransactDeleteCategorysMutation, TError, TransactDeleteCategorysMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransactDeleteCategorysMutation, TError, TransactDeleteCategorysMutationVariables, TContext>(
      ['transactDeleteCategorys'],
      (variables?: TransactDeleteCategorysMutationVariables) => fetcher<TransactDeleteCategorysMutation, TransactDeleteCategorysMutationVariables>(client, TransactDeleteCategorysDocument, variables, headers)(),
      options
    );
export const GetMenuDocument = `
    query getMenu($SDK_ID: ID!) {
  getMenu(SDK_ID: $SDK_ID) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
  }
}
    `;
export const useGetMenuQuery = <
      TData = GetMenuQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMenuQueryVariables,
      options?: UseQueryOptions<GetMenuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMenuQuery, TError, TData>(
      ['getMenu', variables],
      fetcher<GetMenuQuery, GetMenuQueryVariables>(client, GetMenuDocument, variables, headers),
      options
    );
export const GetMenuForPhrDocument = `
    mutation getMenuForPHR($SDK_ID: ID!) {
  getMenu(SDK_ID: $SDK_ID) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    status
    time
    type
    isDelete
    index
  }
}
    `;
export const useGetMenuForPhrMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetMenuForPhrMutation, TError, GetMenuForPhrMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetMenuForPhrMutation, TError, GetMenuForPhrMutationVariables, TContext>(
      ['getMenuForPHR'],
      (variables?: GetMenuForPhrMutationVariables) => fetcher<GetMenuForPhrMutation, GetMenuForPhrMutationVariables>(client, GetMenuForPhrDocument, variables, headers)(),
      options
    );
export const ListMenuDocument = `
    query listMenu($clinic_id: ID!) {
  listMenu(clinic_id: $clinic_id) {
    Menus {
      amount
      role
      name
      abbreviation
      subCategoryId
      parts
      status
      time
      type
      courponId
      SDK_ID
      isDelete
      index
      clinic_id
    }
  }
}
    `;
export const useListMenuQuery = <
      TData = ListMenuQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListMenuQueryVariables,
      options?: UseQueryOptions<ListMenuQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListMenuQuery, TError, TData>(
      ['listMenu', variables],
      fetcher<ListMenuQuery, ListMenuQueryVariables>(client, ListMenuDocument, variables, headers),
      options
    );
export const ListMenuNameDocument = `
    query listMenuName($clinic_id: ID!) {
  listMenu(clinic_id: $clinic_id) {
    Menus {
      SDK_ID
      name
      abbreviation
      isDelete
    }
  }
}
    `;
export const useListMenuNameQuery = <
      TData = ListMenuNameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListMenuNameQueryVariables,
      options?: UseQueryOptions<ListMenuNameQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListMenuNameQuery, TError, TData>(
      ['listMenuName', variables],
      fetcher<ListMenuNameQuery, ListMenuNameQueryVariables>(client, ListMenuNameDocument, variables, headers),
      options
    );
export const AddMenuDocument = `
    mutation addMenu($amount: Int, $role: String!, $name: String!, $abbreviation: String, $subCategoryId: ID!, $parts: String, $status: String!, $type: String!, $time: Int, $isDelete: Boolean, $index: Int, $clinic_id: ID!) {
  addMenu(amount: $amount, role: $role, name: $name, abbreviation: $abbreviation, subCategoryId: $subCategoryId, parts: $parts, status: $status, time: $time, type: $type, isDelete: $isDelete, index: $index, clinic_id: $clinic_id) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
    clinic_id
  }
}
    `;
export const useAddMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMenuMutation, TError, AddMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMenuMutation, TError, AddMenuMutationVariables, TContext>(
      ['addMenu'],
      (variables?: AddMenuMutationVariables) => fetcher<AddMenuMutation, AddMenuMutationVariables>(client, AddMenuDocument, variables, headers)(),
      options
    );
export const DeleteMenuDocument = `
    mutation deleteMenu($SDK_ID: ID!) {
  deleteMenu(SDK_ID: $SDK_ID) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
  }
}
    `;
export const useDeleteMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteMenuMutation, TError, DeleteMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteMenuMutation, TError, DeleteMenuMutationVariables, TContext>(
      ['deleteMenu'],
      (variables?: DeleteMenuMutationVariables) => fetcher<DeleteMenuMutation, DeleteMenuMutationVariables>(client, DeleteMenuDocument, variables, headers)(),
      options
    );
export const BatchDeleteMenuDocument = `
    mutation batchDeleteMenu($SDK_IDs: [ID!]!) {
  batchDeleteMenu(SDK_IDs: $SDK_IDs) {
    SDK_ID
    amount
    courponId
    role
    name
    abbreviation
    subCategoryId
    parts
    status
    time
    type
    isDelete
    index
  }
}
    `;
export const useBatchDeleteMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchDeleteMenuMutation, TError, BatchDeleteMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchDeleteMenuMutation, TError, BatchDeleteMenuMutationVariables, TContext>(
      ['batchDeleteMenu'],
      (variables?: BatchDeleteMenuMutationVariables) => fetcher<BatchDeleteMenuMutation, BatchDeleteMenuMutationVariables>(client, BatchDeleteMenuDocument, variables, headers)(),
      options
    );
export const UpDateMenuDocument = `
    mutation upDateMenu($SDK_ID: ID!, $amount: Int, $role: String, $name: String, $abbreviation: String, $subCategoryId: ID, $status: String, $type: String, $time: Int, $isDelete: Boolean, $index: Int) {
  updateMenu(SDK_ID: $SDK_ID, amount: $amount, role: $role, name: $name, abbreviation: $abbreviation, subCategoryId: $subCategoryId, status: $status, time: $time, type: $type, isDelete: $isDelete, index: $index) {
    SDK_ID
    amount
    role
    name
    abbreviation
    subCategoryId
    status
    time
    type
    isDelete
    index
  }
}
    `;
export const useUpDateMenuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpDateMenuMutation, TError, UpDateMenuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpDateMenuMutation, TError, UpDateMenuMutationVariables, TContext>(
      ['upDateMenu'],
      (variables?: UpDateMenuMutationVariables) => fetcher<UpDateMenuMutation, UpDateMenuMutationVariables>(client, UpDateMenuDocument, variables, headers)(),
      options
    );
export const TransactDeleteMenusDocument = `
    mutation transactDeleteMenus($SDK_IDs: [ID!]!) {
  transactDeleteMenus(SDK_IDs: $SDK_IDs) {
    TransactReturn
  }
}
    `;
export const useTransactDeleteMenusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransactDeleteMenusMutation, TError, TransactDeleteMenusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransactDeleteMenusMutation, TError, TransactDeleteMenusMutationVariables, TContext>(
      ['transactDeleteMenus'],
      (variables?: TransactDeleteMenusMutationVariables) => fetcher<TransactDeleteMenusMutation, TransactDeleteMenusMutationVariables>(client, TransactDeleteMenusDocument, variables, headers)(),
      options
    );
export const TransactIndexMenusDocument = `
    mutation transactIndexMenus($ModifyIndexMenus: [ModifyIndexMenus!]!) {
  transactIndexMenus(ModifyIndexMenus: $ModifyIndexMenus) {
    TransactReturn
  }
}
    `;
export const useTransactIndexMenusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransactIndexMenusMutation, TError, TransactIndexMenusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransactIndexMenusMutation, TError, TransactIndexMenusMutationVariables, TContext>(
      ['transactIndexMenus'],
      (variables?: TransactIndexMenusMutationVariables) => fetcher<TransactIndexMenusMutation, TransactIndexMenusMutationVariables>(client, TransactIndexMenusDocument, variables, headers)(),
      options
    );
export const ListPeriodNotificationDocument = `
    query listPeriodNotification($access_token: String!, $startDate: AWSTimestamp!, $endDate: AWSTimestamp!) {
  listPeriodNotification(endDate: $endDate, access_token: $access_token, startDate: $startDate) {
    Notifications {
      id
      number
      date
      content
      category
    }
  }
}
    `;
export const useListPeriodNotificationQuery = <
      TData = ListPeriodNotificationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPeriodNotificationQueryVariables,
      options?: UseQueryOptions<ListPeriodNotificationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPeriodNotificationQuery, TError, TData>(
      ['listPeriodNotification', variables],
      fetcher<ListPeriodNotificationQuery, ListPeriodNotificationQueryVariables>(client, ListPeriodNotificationDocument, variables, headers),
      options
    );
export const GetOrgDocument = `
    query getOrg($org_id: ID!) {
  getOrg(org_id: $org_id) {
    org_id
    org_label
    org_name
    isDelete
    created_at
    updated_at
  }
}
    `;
export const useGetOrgQuery = <
      TData = GetOrgQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrgQueryVariables,
      options?: UseQueryOptions<GetOrgQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrgQuery, TError, TData>(
      ['getOrg', variables],
      fetcher<GetOrgQuery, GetOrgQueryVariables>(client, GetOrgDocument, variables, headers),
      options
    );
export const GetOrgLabelDocument = `
    query getOrgLabel($org_id: ID!) {
  getOrg(org_id: $org_id) {
    org_label
  }
}
    `;
export const useGetOrgLabelQuery = <
      TData = GetOrgLabelQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrgLabelQueryVariables,
      options?: UseQueryOptions<GetOrgLabelQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrgLabelQuery, TError, TData>(
      ['getOrgLabel', variables],
      fetcher<GetOrgLabelQuery, GetOrgLabelQueryVariables>(client, GetOrgLabelDocument, variables, headers),
      options
    );
export const IsEntryDocument = `
    query isEntry($access_token: String) {
  isEntry(access_token: $access_token) {
    isEntry
  }
}
    `;
export const useIsEntryQuery = <
      TData = IsEntryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: IsEntryQueryVariables,
      options?: UseQueryOptions<IsEntryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<IsEntryQuery, TError, TData>(
      variables === undefined ? ['isEntry'] : ['isEntry', variables],
      fetcher<IsEntryQuery, IsEntryQueryVariables>(client, IsEntryDocument, variables, headers),
      options
    );
export const GetPatientsDocument = `
    query getPatients($access_token: String!) {
  getPatients(access_token: $access_token) {
    DNumber
    SNumber
    address {
      house
      post
      prefectures
    }
    age
    birthday
    comment
    email
    gender
    group
    invitationNumber
    kana {
      first
      last
    }
    name {
      first
      last
    }
    remarks
    searchName
    searchFull
    searchKana
    tel
    undefinedToken
    notEntry
    status
  }
}
    `;
export const useGetPatientsQuery = <
      TData = GetPatientsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientsQueryVariables,
      options?: UseQueryOptions<GetPatientsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientsQuery, TError, TData>(
      ['getPatients', variables],
      fetcher<GetPatientsQuery, GetPatientsQueryVariables>(client, GetPatientsDocument, variables, headers),
      options
    );
export const ListPatientsByNameDocument = `
    query listPatientsByName($name: String!) {
  listPatientsByName(name: $name) {
    Patients {
      id
      DNumber
      SNumber
      age
      address {
        house
        post
        prefectures
      }
      birthday
      comment
      email
      gender
      group
      invitationNumber
      kana {
        first
        last
      }
      lineId
      name {
        first
        last
      }
      remarks
      searchName
      searchFull
      searchKana
      tel
      status
    }
  }
}
    `;
export const useListPatientsByNameQuery = <
      TData = ListPatientsByNameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPatientsByNameQueryVariables,
      options?: UseQueryOptions<ListPatientsByNameQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPatientsByNameQuery, TError, TData>(
      ['listPatientsByName', variables],
      fetcher<ListPatientsByNameQuery, ListPatientsByNameQueryVariables>(client, ListPatientsByNameDocument, variables, headers),
      options
    );
export const GetPatientsByNumberDocument = `
    query getPatientsByNumber($number: Int!, $type: String!) {
  getPatientsByNumber(number: $number, type: $type) {
    DNumber
    SNumber
    address {
      house
      post
      prefectures
    }
    age
    birthday
    comment
    email
    gender
    group
    id
    invitationNumber
    kana {
      first
      last
    }
    lineId
    name {
      first
      last
    }
    remarks
    searchName
    searchFull
    searchKana
    tel
    status
  }
}
    `;
export const useGetPatientsByNumberQuery = <
      TData = GetPatientsByNumberQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientsByNumberQueryVariables,
      options?: UseQueryOptions<GetPatientsByNumberQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientsByNumberQuery, TError, TData>(
      ['getPatientsByNumber', variables],
      fetcher<GetPatientsByNumberQuery, GetPatientsByNumberQueryVariables>(client, GetPatientsByNumberDocument, variables, headers),
      options
    );
export const CheckPatientsDocument = `
    query checkPatients($DNumber: Int!, $SNumber: Int!) {
  checkPatients(DNumber: $DNumber, SNumber: $SNumber) {
    isPatients
  }
}
    `;
export const useCheckPatientsQuery = <
      TData = CheckPatientsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckPatientsQueryVariables,
      options?: UseQueryOptions<CheckPatientsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckPatientsQuery, TError, TData>(
      ['checkPatients', variables],
      fetcher<CheckPatientsQuery, CheckPatientsQueryVariables>(client, CheckPatientsDocument, variables, headers),
      options
    );
export const GetPatientsForBackOfficeDocument = `
    query getPatientsForBackOffice($id: ID!) {
  getPatientsForBackOffice(id: $id) {
    comment
    id
    lineId
    group
    gender
    email
    birthday
    age
    address {
      house
      post
      prefectures
    }
    SNumber
    DNumber
    invitationNumber
    kana {
      first
      last
    }
    name {
      first
      last
    }
    remarks
    searchName
    searchFull
    searchKana
    tel
    status
  }
}
    `;
export const useGetPatientsForBackOfficeQuery = <
      TData = GetPatientsForBackOfficeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientsForBackOfficeQueryVariables,
      options?: UseQueryOptions<GetPatientsForBackOfficeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientsForBackOfficeQuery, TError, TData>(
      ['getPatientsForBackOffice', variables],
      fetcher<GetPatientsForBackOfficeQuery, GetPatientsForBackOfficeQueryVariables>(client, GetPatientsForBackOfficeDocument, variables, headers),
      options
    );
export const ListPatientsDocument = `
    query listPatients($clinic_id: ID!) {
  listPatients(clinic_id: $clinic_id) {
    Patients {
      DNumber
      SNumber
      address {
        house
        post
        prefectures
      }
      id
      lineId
      age
      birthday
      comment
      email
      gender
      group
      invitationNumber
      kana {
        last
        first
      }
      remarks
      searchName
      searchFull
      searchKana
      tel
      name {
        first
        last
      }
      status
      clinic_id
    }
  }
}
    `;
export const useListPatientsQuery = <
      TData = ListPatientsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListPatientsQueryVariables,
      options?: UseQueryOptions<ListPatientsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListPatientsQuery, TError, TData>(
      ['listPatients', variables],
      fetcher<ListPatientsQuery, ListPatientsQueryVariables>(client, ListPatientsDocument, variables, headers),
      options
    );
export const AddPatientsDocument = `
    mutation addPatients($DNumber: Int, $SNumber: Int, $address: addressInput!, $age: Int, $birthday: AWSTimestamp!, $comment: String, $email: String, $gender: String!, $group: String, $access_token: String!, $kana: NameInput!, $name: NameInput!, $remarks: String, $searchFull: String!, $searchKana: String!, $tel: String!, $invitationNumber: String, $clinic_id: ID!) {
  addPatients(address: $address, age: $age, birthday: $birthday, comment: $comment, email: $email, gender: $gender, group: $group, access_token: $access_token, kana: $kana, name: $name, remarks: $remarks, searchFull: $searchFull, searchKana: $searchKana, tel: $tel, SNumber: $SNumber, DNumber: $DNumber, invitationNumber: $invitationNumber, clinic_id: $clinic_id) {
    DNumber
    SNumber
    address {
      house
      post
      prefectures
    }
    age
    birthday
    comment
    email
    gender
    group
    kana {
      first
      last
    }
    name {
      first
      last
    }
    remarks
    searchName
    searchFull
    searchKana
    tel
    invitationNumber
    status
    clinic_id
  }
}
    `;
export const useAddPatientsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPatientsMutation, TError, AddPatientsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddPatientsMutation, TError, AddPatientsMutationVariables, TContext>(
      ['addPatients'],
      (variables?: AddPatientsMutationVariables) => fetcher<AddPatientsMutation, AddPatientsMutationVariables>(client, AddPatientsDocument, variables, headers)(),
      options
    );
export const AddPatientsByIdDocument = `
    mutation addPatientsById($DNumber: Int, $SNumber: Int, $address: addressUpdateInput, $age: Int, $birthday: AWSTimestamp, $comment: String, $email: String, $gender: String, $group: String, $kana: NameInput!, $name: NameInput!, $remarks: String, $searchFull: String!, $searchKana: String!, $tel: String, $invitationNumber: String, $clinic_id: ID!) {
  addPatientsById(address: $address, age: $age, birthday: $birthday, comment: $comment, email: $email, gender: $gender, group: $group, kana: $kana, name: $name, remarks: $remarks, searchFull: $searchFull, searchKana: $searchKana, tel: $tel, SNumber: $SNumber, DNumber: $DNumber, invitationNumber: $invitationNumber, clinic_id: $clinic_id) {
    DNumber
    SNumber
    address {
      house
      post
      prefectures
    }
    id
    lineId
    age
    birthday
    comment
    email
    gender
    group
    kana {
      first
      last
    }
    name {
      first
      last
    }
    remarks
    searchName
    searchFull
    searchKana
    tel
    invitationNumber
    status
    clinic_id
  }
}
    `;
export const useAddPatientsByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPatientsByIdMutation, TError, AddPatientsByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddPatientsByIdMutation, TError, AddPatientsByIdMutationVariables, TContext>(
      ['addPatientsById'],
      (variables?: AddPatientsByIdMutationVariables) => fetcher<AddPatientsByIdMutation, AddPatientsByIdMutationVariables>(client, AddPatientsByIdDocument, variables, headers)(),
      options
    );
export const AddPatientsByQrDocument = `
    mutation addPatientsByQR($id: ID!, $access_token: String!) {
  addPatientsByQR(access_token: $access_token, id: $id) {
    id
    lineId
    name {
      first
      last
    }
    kana {
      first
      last
    }
    status
  }
}
    `;
export const useAddPatientsByQrMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPatientsByQrMutation, TError, AddPatientsByQrMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddPatientsByQrMutation, TError, AddPatientsByQrMutationVariables, TContext>(
      ['addPatientsByQR'],
      (variables?: AddPatientsByQrMutationVariables) => fetcher<AddPatientsByQrMutation, AddPatientsByQrMutationVariables>(client, AddPatientsByQrDocument, variables, headers)(),
      options
    );
export const UpdatePatientsDocument = `
    mutation updatePatients($address: addressUpdateInput, $age: Int, $birthday: AWSTimestamp, $comment: String, $DNumber: Int, $SNumber: Int, $email: String, $gender: String, $access_token: String!, $invitationNumber: String, $group: String, $kana: NameUpdateInput, $name: NameUpdateInput, $searchFull: String, $searchKana: String, $tel: String, $remarks: String) {
  updatePatients(address: $address, age: $age, birthday: $birthday, comment: $comment, DNumber: $DNumber, email: $email, gender: $gender, access_token: $access_token, invitationNumber: $invitationNumber, group: $group, kana: $kana, name: $name, remarks: $remarks, searchFull: $searchFull, searchKana: $searchKana, SNumber: $SNumber, tel: $tel) {
    DNumber
    SNumber
    address {
      house
      post
      prefectures
    }
    age
    birthday
    comment
    email
    gender
    group
    invitationNumber
    kana {
      first
      last
    }
    name {
      first
      last
    }
    remarks
    searchName
    searchFull
    searchKana
    tel
    status
  }
}
    `;
export const useUpdatePatientsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePatientsMutation, TError, UpdatePatientsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePatientsMutation, TError, UpdatePatientsMutationVariables, TContext>(
      ['updatePatients'],
      (variables?: UpdatePatientsMutationVariables) => fetcher<UpdatePatientsMutation, UpdatePatientsMutationVariables>(client, UpdatePatientsDocument, variables, headers)(),
      options
    );
export const UpdatePatientsByIdDocument = `
    mutation updatePatientsById($id: ID!, $address: addressUpdateInput, $age: Int, $birthday: AWSTimestamp, $comment: String, $DNumber: Int, $SNumber: Int, $email: String, $gender: String, $invitationNumber: String, $group: String, $kana: NameUpdateInput, $name: NameUpdateInput, $searchFull: String, $searchKana: String, $tel: String, $remarks: String) {
  updatePatientsById(address: $address, age: $age, birthday: $birthday, comment: $comment, DNumber: $DNumber, email: $email, gender: $gender, id: $id, invitationNumber: $invitationNumber, group: $group, kana: $kana, name: $name, remarks: $remarks, searchFull: $searchFull, searchKana: $searchKana, SNumber: $SNumber, tel: $tel) {
    DNumber
    SNumber
    address {
      house
      post
      prefectures
    }
    age
    id
    birthday
    comment
    email
    gender
    group
    invitationNumber
    kana {
      first
      last
    }
    name {
      first
      last
    }
    remarks
    searchName
    searchFull
    searchKana
    tel
    status
  }
}
    `;
export const useUpdatePatientsByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePatientsByIdMutation, TError, UpdatePatientsByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePatientsByIdMutation, TError, UpdatePatientsByIdMutationVariables, TContext>(
      ['updatePatientsById'],
      (variables?: UpdatePatientsByIdMutationVariables) => fetcher<UpdatePatientsByIdMutation, UpdatePatientsByIdMutationVariables>(client, UpdatePatientsByIdDocument, variables, headers)(),
      options
    );
export const DeletePatientsByIdDocument = `
    mutation deletePatientsById($id: ID!) {
  deletePatientsById(id: $id) {
    id
    status
  }
}
    `;
export const useDeletePatientsByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePatientsByIdMutation, TError, DeletePatientsByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePatientsByIdMutation, TError, DeletePatientsByIdMutationVariables, TContext>(
      ['deletePatientsById'],
      (variables?: DeletePatientsByIdMutationVariables) => fetcher<DeletePatientsByIdMutation, DeletePatientsByIdMutationVariables>(client, DeletePatientsByIdDocument, variables, headers)(),
      options
    );
export const GetFormDocument = `
    query getForm($access_token: String!) {
  getForm(access_token: $access_token) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
        commentQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useGetFormQuery = <
      TData = GetFormQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFormQueryVariables,
      options?: UseQueryOptions<GetFormQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetFormQuery, TError, TData>(
      ['getForm', variables],
      fetcher<GetFormQuery, GetFormQueryVariables>(client, GetFormDocument, variables, headers),
      options
    );
export const GetCommonFormByIdDocument = `
    query getCommonFormById($id: ID!) {
  getFormById(id: $id) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useGetCommonFormByIdQuery = <
      TData = GetCommonFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCommonFormByIdQueryVariables,
      options?: UseQueryOptions<GetCommonFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCommonFormByIdQuery, TError, TData>(
      ['getCommonFormById', variables],
      fetcher<GetCommonFormByIdQuery, GetCommonFormByIdQueryVariables>(client, GetCommonFormByIdDocument, variables, headers),
      options
    );
export const GetMedicalFormByIdDocument = `
    query getMedicalFormById($id: ID!) {
  getFormById(id: $id) {
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selectedQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        commentQ4
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useGetMedicalFormByIdQuery = <
      TData = GetMedicalFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMedicalFormByIdQueryVariables,
      options?: UseQueryOptions<GetMedicalFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMedicalFormByIdQuery, TError, TData>(
      ['getMedicalFormById', variables],
      fetcher<GetMedicalFormByIdQuery, GetMedicalFormByIdQueryVariables>(client, GetMedicalFormByIdDocument, variables, headers),
      options
    );
export const GetDentalFormByIdDocument = `
    query getDentalFormById($id: ID!) {
  getFormById(id: $id) {
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
  }
}
    `;
export const useGetDentalFormByIdQuery = <
      TData = GetDentalFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDentalFormByIdQueryVariables,
      options?: UseQueryOptions<GetDentalFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDentalFormByIdQuery, TError, TData>(
      ['getDentalFormById', variables],
      fetcher<GetDentalFormByIdQuery, GetDentalFormByIdQueryVariables>(client, GetDentalFormByIdDocument, variables, headers),
      options
    );
export const GetOrthodonticsFormByIdDocument = `
    query getOrthodonticsFormById($id: ID!) {
  getFormById(id: $id) {
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
      Q10 {
        commentQ10
        selectedQ10
      }
    }
  }
}
    `;
export const useGetOrthodonticsFormByIdQuery = <
      TData = GetOrthodonticsFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrthodonticsFormByIdQueryVariables,
      options?: UseQueryOptions<GetOrthodonticsFormByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrthodonticsFormByIdQuery, TError, TData>(
      ['getOrthodonticsFormById', variables],
      fetcher<GetOrthodonticsFormByIdQuery, GetOrthodonticsFormByIdQueryVariables>(client, GetOrthodonticsFormByIdDocument, variables, headers),
      options
    );
export const AddCommonFormDocument = `
    mutation addCommonForm($access_token: String!, $common: CommonInput!) {
  addForm(access_token: $access_token, common: $common) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        dateQ6
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddCommonFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommonFormMutation, TError, AddCommonFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommonFormMutation, TError, AddCommonFormMutationVariables, TContext>(
      ['addCommonForm'],
      (variables?: AddCommonFormMutationVariables) => fetcher<AddCommonFormMutation, AddCommonFormMutationVariables>(client, AddCommonFormDocument, variables, headers)(),
      options
    );
export const AddCommonFormByIdDocument = `
    mutation addCommonFormById($id: ID!, $common: CommonInput!) {
  addFormById(id: $id, common: $common) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        dateQ6
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddCommonFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCommonFormByIdMutation, TError, AddCommonFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCommonFormByIdMutation, TError, AddCommonFormByIdMutationVariables, TContext>(
      ['addCommonFormById'],
      (variables?: AddCommonFormByIdMutationVariables) => fetcher<AddCommonFormByIdMutation, AddCommonFormByIdMutationVariables>(client, AddCommonFormByIdDocument, variables, headers)(),
      options
    );
export const AddDentalFormDocument = `
    mutation addDentalForm($access_token: String!, $dental: DentalInput!) {
  addForm(access_token: $access_token, dental: $dental) {
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
  }
}
    `;
export const useAddDentalFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddDentalFormMutation, TError, AddDentalFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddDentalFormMutation, TError, AddDentalFormMutationVariables, TContext>(
      ['addDentalForm'],
      (variables?: AddDentalFormMutationVariables) => fetcher<AddDentalFormMutation, AddDentalFormMutationVariables>(client, AddDentalFormDocument, variables, headers)(),
      options
    );
export const AddDentalFormByIdDocument = `
    mutation addDentalFormById($id: ID!, $dental: DentalInput!) {
  addFormById(id: $id, dental: $dental) {
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
  }
}
    `;
export const useAddDentalFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddDentalFormByIdMutation, TError, AddDentalFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddDentalFormByIdMutation, TError, AddDentalFormByIdMutationVariables, TContext>(
      ['addDentalFormById'],
      (variables?: AddDentalFormByIdMutationVariables) => fetcher<AddDentalFormByIdMutation, AddDentalFormByIdMutationVariables>(client, AddDentalFormByIdDocument, variables, headers)(),
      options
    );
export const AddMedicalFormDocument = `
    mutation addMedicalForm($access_token: String!, $medical: MedicalInput!) {
  addForm(access_token: $access_token, medical: $medical) {
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddMedicalFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMedicalFormMutation, TError, AddMedicalFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMedicalFormMutation, TError, AddMedicalFormMutationVariables, TContext>(
      ['addMedicalForm'],
      (variables?: AddMedicalFormMutationVariables) => fetcher<AddMedicalFormMutation, AddMedicalFormMutationVariables>(client, AddMedicalFormDocument, variables, headers)(),
      options
    );
export const AddMedicalFormByIdDocument = `
    mutation addMedicalFormById($id: ID!, $medical: MedicalInput!) {
  addFormById(id: $id, medical: $medical) {
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
  }
}
    `;
export const useAddMedicalFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMedicalFormByIdMutation, TError, AddMedicalFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMedicalFormByIdMutation, TError, AddMedicalFormByIdMutationVariables, TContext>(
      ['addMedicalFormById'],
      (variables?: AddMedicalFormByIdMutationVariables) => fetcher<AddMedicalFormByIdMutation, AddMedicalFormByIdMutationVariables>(client, AddMedicalFormByIdDocument, variables, headers)(),
      options
    );
export const AddOrthodonticsFormDocument = `
    mutation addOrthodonticsForm($access_token: String!, $orthodontics: OrthodonticsInput!) {
  addForm(access_token: $access_token, orthodontics: $orthodontics) {
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
      Q10 {
        commentQ10
        selectedQ10
      }
    }
  }
}
    `;
export const useAddOrthodonticsFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddOrthodonticsFormMutation, TError, AddOrthodonticsFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddOrthodonticsFormMutation, TError, AddOrthodonticsFormMutationVariables, TContext>(
      ['addOrthodonticsForm'],
      (variables?: AddOrthodonticsFormMutationVariables) => fetcher<AddOrthodonticsFormMutation, AddOrthodonticsFormMutationVariables>(client, AddOrthodonticsFormDocument, variables, headers)(),
      options
    );
export const AddOrthodonticsFormByIdDocument = `
    mutation addOrthodonticsFormById($id: ID!, $orthodontics: OrthodonticsInput!) {
  addFormById(id: $id, orthodontics: $orthodontics) {
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
      Q10 {
        commentQ10
        selectedQ10
      }
    }
  }
}
    `;
export const useAddOrthodonticsFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddOrthodonticsFormByIdMutation, TError, AddOrthodonticsFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddOrthodonticsFormByIdMutation, TError, AddOrthodonticsFormByIdMutationVariables, TContext>(
      ['addOrthodonticsFormById'],
      (variables?: AddOrthodonticsFormByIdMutationVariables) => fetcher<AddOrthodonticsFormByIdMutation, AddOrthodonticsFormByIdMutationVariables>(client, AddOrthodonticsFormByIdDocument, variables, headers)(),
      options
    );
export const AddFormDocument = `
    mutation addForm($access_token: String!, $common: CommonInput, $dental: DentalInput, $medical: MedicalInput, $orthodontics: OrthodonticsInput) {
  addForm(access_token: $access_token, common: $common, dental: $dental, medical: $medical, orthodontics: $orthodontics) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useAddFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFormMutation, TError, AddFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFormMutation, TError, AddFormMutationVariables, TContext>(
      ['addForm'],
      (variables?: AddFormMutationVariables) => fetcher<AddFormMutation, AddFormMutationVariables>(client, AddFormDocument, variables, headers)(),
      options
    );
export const AddFormByIdDocument = `
    mutation addFormById($id: ID!, $common: CommonInput, $dental: DentalInput, $medical: MedicalInput, $orthodontics: OrthodonticsInput) {
  addFormById(id: $id, common: $common, dental: $dental, medical: $medical, orthodontics: $orthodontics) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useAddFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddFormByIdMutation, TError, AddFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddFormByIdMutation, TError, AddFormByIdMutationVariables, TContext>(
      ['addFormById'],
      (variables?: AddFormByIdMutationVariables) => fetcher<AddFormByIdMutation, AddFormByIdMutationVariables>(client, AddFormByIdDocument, variables, headers)(),
      options
    );
export const DeleteFormDocument = `
    mutation deleteForm($access_token: String!) {
  deleteForm(access_token: $access_token) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selectedQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        commentQ4
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        commentQ7
        selectedQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useDeleteFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFormMutation, TError, DeleteFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFormMutation, TError, DeleteFormMutationVariables, TContext>(
      ['deleteForm'],
      (variables?: DeleteFormMutationVariables) => fetcher<DeleteFormMutation, DeleteFormMutationVariables>(client, DeleteFormDocument, variables, headers)(),
      options
    );
export const DeleteFormByIdDocument = `
    mutation deleteFormById($id: ID!) {
  deleteFormById(id: $id) {
    common {
      Q1 {
        answerQ1
        diseaseQ1
        selected_clinicQ1
        selected_medicineQ1
      }
      Q2 {
        answerQ2
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        selectedQ3
      }
      Q4 {
        answerQ4
        selectedQ4
        selected_optionsQ4
      }
      Q5 {
        answerQ5
      }
      Q6 {
        answerQ6
        commentQ6
        dateQ6
        selectedQ6
      }
    }
    dental {
      Q1 {
        commentQ1
        dateQ1
        selectedQ1
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        selectedQ3
      }
      Q4 {
        selectedQ4
      }
      Q5 {
        selectedQ5
      }
    }
    medical {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q2 {
        bodyQ2
        commentQ2
        faceQ2
      }
      Q3 {
        answerQ3
        clinic_anotherQ3
        clinic_otherQ3
        clinic_salonQ3
        selectedQ3
        selected_fatDissolvingQ3
        selected_laserQ3
        selected_peelingQ3
      }
      Q4 {
        commentQ4
        constipationQ4
        favoriteQ4
        selectedQ4
        sleepQ4
        stomachQ4
        ultravioletRaysQ4
      }
      Q5 {
        doctorsCosmeQ5
        selectedQ5
        skincareItemQ5
      }
      Q6 {
        commentQ6
        selectedQ6
      }
    }
    orthodontics {
      Q1 {
        commentQ1
        selectedQ1
      }
      Q10 {
        commentQ10
        selectedQ10
      }
      Q2 {
        commentQ2
        selectedQ2
      }
      Q3 {
        answerQ3
        commentQ3
        dateQ3
      }
      Q4 {
        answerQ4
        dateQ4
      }
      Q5 {
        commentQ5
        dateQ5
        selectedQ5
      }
      Q6 {
        selectedQ6
      }
      Q7 {
        selectedQ7
        commentQ7
      }
      Q8 {
        answerQ8
      }
      Q9 {
        selectedQ9
      }
    }
  }
}
    `;
export const useDeleteFormByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFormByIdMutation, TError, DeleteFormByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFormByIdMutation, TError, DeleteFormByIdMutationVariables, TContext>(
      ['deleteFormById'],
      (variables?: DeleteFormByIdMutationVariables) => fetcher<DeleteFormByIdMutation, DeleteFormByIdMutationVariables>(client, DeleteFormByIdDocument, variables, headers)(),
      options
    );
export const GetRolesDocument = `
    query getRoles($id: ID!) {
  getRoles(id: $id) {
    id
    name
    status
  }
}
    `;
export const useGetRolesQuery = <
      TData = GetRolesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRolesQueryVariables,
      options?: UseQueryOptions<GetRolesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRolesQuery, TError, TData>(
      ['getRoles', variables],
      fetcher<GetRolesQuery, GetRolesQueryVariables>(client, GetRolesDocument, variables, headers),
      options
    );
export const ListRolesDocument = `
    query listRoles($clinic_id: ID!) {
  listRoles(clinic_id: $clinic_id) {
    Roles {
      id
      name
      status
      clinic_id
    }
  }
}
    `;
export const useListRolesQuery = <
      TData = ListRolesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListRolesQueryVariables,
      options?: UseQueryOptions<ListRolesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListRolesQuery, TError, TData>(
      ['listRoles', variables],
      fetcher<ListRolesQuery, ListRolesQueryVariables>(client, ListRolesDocument, variables, headers),
      options
    );
export const AddRolesDocument = `
    mutation addRoles($name: String, $status: Boolean, $clinic_id: ID!) {
  addRoles(name: $name, status: $status, clinic_id: $clinic_id) {
    id
    name
    status
    clinic_id
  }
}
    `;
export const useAddRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddRolesMutation, TError, AddRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddRolesMutation, TError, AddRolesMutationVariables, TContext>(
      ['addRoles'],
      (variables?: AddRolesMutationVariables) => fetcher<AddRolesMutation, AddRolesMutationVariables>(client, AddRolesDocument, variables, headers)(),
      options
    );
export const DeleteRolesDocument = `
    mutation deleteRoles($id: ID!) {
  deleteRoles(id: $id) {
    id
    name
    status
  }
}
    `;
export const useDeleteRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteRolesMutation, TError, DeleteRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteRolesMutation, TError, DeleteRolesMutationVariables, TContext>(
      ['deleteRoles'],
      (variables?: DeleteRolesMutationVariables) => fetcher<DeleteRolesMutation, DeleteRolesMutationVariables>(client, DeleteRolesDocument, variables, headers)(),
      options
    );
export const UpdateRolesDocument = `
    mutation updateRoles($id: ID!, $name: String, $status: Boolean) {
  updateRoles(id: $id, name: $name, status: $status) {
    id
    name
    status
  }
}
    `;
export const useUpdateRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRolesMutation, TError, UpdateRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateRolesMutation, TError, UpdateRolesMutationVariables, TContext>(
      ['updateRoles'],
      (variables?: UpdateRolesMutationVariables) => fetcher<UpdateRolesMutation, UpdateRolesMutationVariables>(client, UpdateRolesDocument, variables, headers)(),
      options
    );
export const GetShiftDocument = `
    query getShift($date: AWSTimestamp!, $id: ID!) {
  getShift(date: $date, id: $id) {
    id
    date
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useGetShiftQuery = <
      TData = GetShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetShiftQueryVariables,
      options?: UseQueryOptions<GetShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetShiftQuery, TError, TData>(
      ['getShift', variables],
      fetcher<GetShiftQuery, GetShiftQueryVariables>(client, GetShiftDocument, variables, headers),
      options
    );
export const GetTodayShiftDocument = `
    query getTodayShift($date: AWSTimestamp!) {
  getTodayShift(date: $date) {
    Shifts {
      date
      id
      name
      shifts
      workingTimes {
        am
        pm
      }
    }
  }
}
    `;
export const useGetTodayShiftQuery = <
      TData = GetTodayShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTodayShiftQueryVariables,
      options?: UseQueryOptions<GetTodayShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTodayShiftQuery, TError, TData>(
      ['getTodayShift', variables],
      fetcher<GetTodayShiftQuery, GetTodayShiftQueryVariables>(client, GetTodayShiftDocument, variables, headers),
      options
    );
export const GetWeeklyShiftDocument = `
    query getWeeklyShift($id: ID!, $weekStart: AWSTimestamp!, $weekEnd: AWSTimestamp!) {
  getWeeklyShift(id: $id, weekEnd: $weekEnd, weekStart: $weekStart) {
    Shifts {
      date
      id
      name
      shifts
      workingTimes {
        am
        pm
      }
    }
  }
}
    `;
export const useGetWeeklyShiftQuery = <
      TData = GetWeeklyShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWeeklyShiftQueryVariables,
      options?: UseQueryOptions<GetWeeklyShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetWeeklyShiftQuery, TError, TData>(
      ['getWeeklyShift', variables],
      fetcher<GetWeeklyShiftQuery, GetWeeklyShiftQueryVariables>(client, GetWeeklyShiftDocument, variables, headers),
      options
    );
export const ListShiftDocument = `
    query listShift {
  listShift {
    Shifts {
      date
      id
      name
      shifts
      workingTimes {
        am
        pm
      }
    }
  }
}
    `;
export const useListShiftQuery = <
      TData = ListShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListShiftQueryVariables,
      options?: UseQueryOptions<ListShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListShiftQuery, TError, TData>(
      variables === undefined ? ['listShift'] : ['listShift', variables],
      fetcher<ListShiftQuery, ListShiftQueryVariables>(client, ListShiftDocument, variables, headers),
      options
    );
export const AddShiftDocument = `
    mutation addShift($date: AWSTimestamp!, $id: ID!, $name: String!, $shifts: [Boolean!]!, $workingTimes: workingTimesInput!) {
  addShift(date: $date, id: $id, name: $name, shifts: $shifts, workingTimes: $workingTimes) {
    date
    id
    name
    shifts
    workingTimes {
      pm
      am
    }
  }
}
    `;
export const useAddShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddShiftMutation, TError, AddShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddShiftMutation, TError, AddShiftMutationVariables, TContext>(
      ['addShift'],
      (variables?: AddShiftMutationVariables) => fetcher<AddShiftMutation, AddShiftMutationVariables>(client, AddShiftDocument, variables, headers)(),
      options
    );
export const BatchWriteShiftDocument = `
    mutation batchWriteShift($dates: [AWSTimestamp!]!, $id: ID!, $name: String!, $shifts: [Boolean!]!, $workingTimes: workingTimesInput!) {
  batchWriteShift(dates: $dates, id: $id, name: $name, shifts: $shifts, workingTimes: $workingTimes) {
    date
    id
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useBatchWriteShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchWriteShiftMutation, TError, BatchWriteShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchWriteShiftMutation, TError, BatchWriteShiftMutationVariables, TContext>(
      ['batchWriteShift'],
      (variables?: BatchWriteShiftMutationVariables) => fetcher<BatchWriteShiftMutation, BatchWriteShiftMutationVariables>(client, BatchWriteShiftDocument, variables, headers)(),
      options
    );
export const DeleteShiftDocument = `
    mutation deleteShift($id: ID!, $date: AWSTimestamp!) {
  deleteShift(id: $id, date: $date) {
    date
    id
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useDeleteShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteShiftMutation, TError, DeleteShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteShiftMutation, TError, DeleteShiftMutationVariables, TContext>(
      ['deleteShift'],
      (variables?: DeleteShiftMutationVariables) => fetcher<DeleteShiftMutation, DeleteShiftMutationVariables>(client, DeleteShiftDocument, variables, headers)(),
      options
    );
export const UpdateShiftDocument = `
    mutation updateShift($id: ID!, $date: AWSTimestamp!, $name: String, $shifts: [Boolean!], $workingTime: workingTimesInput) {
  updateShift(id: $id, date: $date, name: $name, shifts: $shifts, workingTimes: $workingTime) {
    date
    id
    name
    shifts
    workingTimes {
      am
      pm
    }
  }
}
    `;
export const useUpdateShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateShiftMutation, TError, UpdateShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateShiftMutation, TError, UpdateShiftMutationVariables, TContext>(
      ['updateShift'],
      (variables?: UpdateShiftMutationVariables) => fetcher<UpdateShiftMutation, UpdateShiftMutationVariables>(client, UpdateShiftDocument, variables, headers)(),
      options
    );